import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  Tooltip,
  IconButton,
  Paper,
  Autocomplete,
  FormHelperText,
  FormLabel,
  InputAdornment,
  Grid,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useLocation, useNavigate } from "react-router-dom";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import BinanceFuturesLtpWebsocket from "./BinanceFuturesLtpWebsocket";
import BinanceLtpWebsocket from "./BinanceLtpWebsocket";
import axios from "axios";
import { useSelector } from "react-redux";
import { ContainedButton } from "../../Common/Buttons";

const FUTURELENDINGURL = WEBSERVICE + "/fMargin/";
const COPYTRADINGSERVICE = WEBSERVICE + "/copyTrading";
const OPTIONSLENDINGURL = WEBSERVICE + "/optionsMargin/";

const futureBinance = new BinanceFuturesLtpWebsocket();
const binanceSocket = new BinanceLtpWebsocket();

const CreateBot = () => {
  const { brokerBasicInfo, btncolor } = useSelector((state) => state);
  const navigate = useNavigate();
  const location = useLocation();
  const botDetails = location.state?.bot;
  const Themecolor = "Dark";
  const [botName, setBotName] = useState("");
  const [botDescription, setBotDescription] = useState("");
  const [marketName, setMarketName] = useState("");
  const [orderType, setOrderType] = useState("");
  const [finalBotAssetPair, setFinalBotAssetPair] = useState("");
  const [isProfit1Checked, setIsProfit1Checked] = useState(false);
  const [isProfit2Checked, setIsProfit2Checked] = useState(false);
  const [isProfit3Checked, setIsProfit3Checked] = useState(false);
  const [isProfit1CheckedForTakeProfit, setIsProfit1CheckedForTakeProfit] =
    useState(false);
  const [isProfit2CheckedForTakeProfit, setIsProfit2CheckedForTakeProfit] =
    useState(false);
  const [isProfit3CheckedForTakeProfit, setIsProfit3CheckedForTakeProfit] =
    useState(false);
  const [fixedAmountForSingleEntryError, setFixedAmountForSingleEntryError] =
    useState(false);
  const [selectedCrypto, setSelectedCrypto] = useState("BTC");
  const [selectedFiat, setSelectedFiat] = useState("USD");
  const [botType, setBotType] = useState("");
  const [selectedApiKey, setSelectedApiKey] = useState([]);

  const [marketPriceReachForBot1, setMarketPriceReachForBot1] = useState("");
  const [pairPriceForBot1, setPairPriceForBot1] = useState("");
  const [deviationFromForBot1, setDeviationFromForBot1] = useState("");
  const [deviationPercentageForBot1, setDeviationPercentageForBot1] =
    useState("");
  const [positionSizeForBot1, setPositionSizeForBot1] = useState("");
  const [percentageOfPortfolioForBot1, setPercentageOfPortfolioForBot1] =
    useState("");
  const [fixedAmountForBot1, setFixedAmountForBot1] = useState("");
  const [balanceList, setBalanceList] = useState(null);
  const [marketPriceReachForBot2, setMarketPriceReachForBot2] = useState("");
  const [pairPriceForBot2, setPairPriceForBot2] = useState("");
  const [deviationFromForBot2, setDeviationFromForBot2] = useState("");
  const [deviationPercentageForBot2, setDeviationPercentageForBot2] =
    useState("");
  const [positionSizeForBot2, setPositionSizeForBot2] = useState("");
  const [percentageOfPortfolioForBot2, setPercentageOfPortfolioForBot2] =
    useState("");
  const [fixedAmountForBot2, setFixedAmountForBot2] = useState("");

  const [marketPriceReachForBot3, setMarketPriceReachForBot3] = useState("");
  const [pairPriceForBot3, setPairPriceForBot3] = useState("");
  const [deviationFromForBot3, setDeviationFromForBot3] = useState("");
  const [deviationPercentageForBot3, setDeviationPercentageForBot3] =
    useState("");
  const [positionSizeForBot3, setPositionSizeForBot3] = useState("");
  const [percentageOfPortfolioForBot3, setPercentageOfPortfolioForBot3] =
    useState("");
  const [fixedAmountForBot3, setFixedAmountForBot3] = useState("");

  const [marketPriceForSingleEntry, setMarketPriceForSingleEntry] =
    useState("");
  const [marketPriceReachForSingleEntry, setMarketPriceReachForSingleEntry] =
    useState("");
  const [
    marketPriceReachTypeForSingleEntry,
    setMarketPriceReachTypeForSingleEntry,
  ] = useState("");
  const [positionSizeForSingleEntry, setPositionSizeForSingleEntry] =
    useState("");
  const [
    percentageOfPortfolioForSingleEntry,
    setPercentageOfPortfolioForSingleEntry,
  ] = useState("");
  const [fixedAmountForSingleEntry, setFixedAmountForSingleEntry] =
    useState("");

  const [
    positionSizeForDollarCostAverage,
    setPositionSizeForDollarCostAverage,
  ] = useState("");
  const [
    percentageOfPortfolioForDollarCostAverage,
    setPercentageOfPortfolioForDollarCostAverage,
  ] = useState("");
  const [fixedAmountForDollarCostAverage, setFixedAmountForDollarCostAverage] =
    useState("");
  const [investTimeForDolarCostAverage, setInvestTimeForDolarCostAverage] =
    useState("");
  const [
    investDurationForDollarCostAverage,
    setInvestDurationForDollarCostAverage,
  ] = useState("");

  const [
    percentageOfPortfolioProfit1ForTakeProfit,
    setPercentageOfPortfolioProfit1ForTakeProfit,
  ] = useState("");
  const [
    percentageOfPortfolioProfit2ForTakeProfit,
    setPercentageOfPortfolioProfit2ForTakeProfit,
  ] = useState("");
  const [
    percentageOfPortfolioProfit3ForTakeProfit,
    setPercentageOfPortfolioProfit3ForTakeProfit,
  ] = useState("");
  const [
    marketPriceReachProfit1ForTakeProfit,
    setMarketPriceReachProfit1ForTakeProfit,
  ] = useState("");
  const [
    marketPriceReachProfit2ForTakeProfit,
    setMarketPriceReachProfit2ForTakeProfit,
  ] = useState("");
  const [
    marketPriceReachProfit3ForTakeProfit,
    setMarketPriceReachProfit3ForTakeProfit,
  ] = useState("");
  const [marketPriceProfit1ForTakeProfit, setMarketPriceProfit1ForTakeProfit] =
    useState("");
  const [marketPriceProfit2ForTakeProfit, setMarketPriceProfit2ForTakeProfit] =
    useState("");
  const [marketPriceProfit3ForTakeProfit, setMarketPriceProfit3ForTakeProfit] =
    useState("");
  const [plPercentProfit1ForTakeProfit, setPlPercentProfit1ForTakeProfit] =
    useState();
  const [plPercentProfit2ForTakeProfit, setPlPercentProfit2ForTakeProfit] =
    useState();
  const [plPercentProfit3ForTakeProfit, setPlPercentProfit3ForTakeProfit] =
    useState();
  const [selectedSellingAssetBalance, setSelectedSellingAssetBalance] =
    useState(0);
  const [apiList, setApiList] = useState([]);
  const [assetetpair, setAssetetpair] = useState([]);

  const [filterCurrency, setFilterCurrency] = useState();
  const [header, setHeader] = useState();
  const [assets, setAssets] = useState();
  const [roccolor, setRoccolor] = useState(false);
  const [ltpcolor, setLtpcolor] = useState(false);
  const [selectedMarginType, setSelectedMarginType] = useState();
  const [balencelist, setBalencelist] = useState();
  const [currencyBalance, setCurrencyBalance] = useState();
  const [selectedCryptoCurrency, setSelectedCryptoCurrency] = useState("");
  const [selelectedBuyingAssetBalance, setSelelectedBuyingAssetBalance] =
    useState();
  const [selelectedSellingAssetBalance, setSelelectedSellingAssetBalance] =
    useState();

  const [botAssetPair, setBotAssetPair] = useState("");
  const [assetPairBack, setAssetPairBack] = useState([]);
  const [botOrder, setBotOrder] = useState("");
  const [botExpireTime, setBotExpireTime] = useState();
  const [botExpireTimeType, setBotExpireTimeType] = useState("min");
  const [marketPriceReachForBotType, setMarketPriceReachForBotType] =
    useState("");
  const [marketPriceReachForBot2Type, setMarketPriceReachForBot2Type] =
    useState("");
  const [marketPriceReachForBot3Type, setMarketPriceReachForBot3Type] =
    useState("");
  const [
    portfolioPercentageProfit1ForTakeProfit1,
    setPortfolioPercentageProfit1ForTakeProfit1,
  ] = useState("0");
  const [
    portfolioPercentageProfit2ForTakeProfit1,
    setPortfolioPercentageProfit2ForTakeProfit1,
  ] = useState("0");
  const [
    portfolioPercentageProfit3ForTakeProfit1,
    setPortfolioPercentageProfit3ForTakeProfit1,
  ] = useState("0");
  const [apiKey, setApiKey] = useState();
  const [
    investTimeForDolarCostAverageType,
    setInvestTimeForDolarCostAverageType,
  ] = useState("");

  const [marketOrderTPError, setMarketOrderTPError] = useState(false);
  const [chartlist, setChartlist] = useState();
  const [ltpData, setLtpData] = useState();

  const [lmodtp1PriceErrorGrt, setLmodtp1PriceErrorGrt] = useState(false);
  const [lmodtp1PriceErrorlwr, setLmodtp1PriceErrorlwr] = useState(false);
  const [lmodtp2PriceErrorlwr, setLmodtp2PriceErrorlwr] = useState();
  const [lmodtp2PriceErrorGrt, setLmodtp2PriceErrorGrt] = useState();
  const [lmodtp3PriceErrorGrt, setLmodtp3PriceErrorGrt] = useState();
  const [lmodtp3PriceErrorlwr, setLmodtp3PriceErrorlwr] = useState();

  const [botAssetPairTrimmed, setBotAssetPairTrimmed] = useState("");
  const [showAsset, setShowAsset] = useState();
  const [moSngEntErrorGrt, setMoSngEntErrorGrt] = useState();
  const [moSngEntErrorlwr, setMoSngEntErrorlwr] = useState();
  const [limitOrderTPError, setLimitOrderTPError] = useState(false);
  const [modtp1PriceErrorGrt, setModtp1PriceErrorGrt] = useState();
  const [modtp1PriceErrorlwr, setModtp1PriceErrorlwr] = useState();
  const [modtp2PriceErrorlwr, setModtp2PriceErrorlwr] = useState();
  const [modtp2PriceErrorGrt, setModtp2PriceErrorGrt] = useState();
  const [modtp3PriceErrorGrt, setModtp3PriceErrorGrt] = useState();
  const [modtp3PriceErrorlwr, setModtp3PriceErrorlwr] = useState();

  const [time_frame, setTimeFrame] = useState("Every Minute");
  const [maximum_trade_count, setMaximumTradeCount] = useState();

  const [dropdownList, setDropdownList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [dropdownSettings, setDropdownSettings] = useState({});

  const [selectedApiKeyMulti, setSelectedApiKeyMulti] = useState();
  const [multiAPIId, setMultiAPIId] = useState([]);
  const [multiIdString, setMultiIdString] = useState("");

  const [marginType, setMarginType] = useState("0");
  const [marginShowStatus, setMarginShowStatus] = useState(false);
  const [leverage, setLeverage] = useState(2);
  const [marginTypeOptionStatus, setMarginTypeOptionStatus] = useState();
  const [togglePercentageForBot1, setTogglePercentageForBot1] = useState("");
  const [baseAssetPair, setBaseAssetPair] = useState("");
  const [exchangeName, setExchangeName] = useState("");
  const [expirationFlag, setExpirationFlag] = useState();
  const [apipublicKey, setApipublicKey] = useState();
  const [apisecretKey, setApisecretKey] = useState();
  const [BinanceLtpDataForPair, setBinanceLtpDataForPair] = useState();
  const [binanceBuySellStatus, setBinanceBuySellStatus] = useState();
  const [BinanceBalanceCheckStatus, setBinanceBalanceCheckStatus] =
    useState(false);
  const [pNlStatus, setPNlStatus] = useState(true);
  const [pNlStatus2, setPNlStatus2] = useState(true);
  const [pNlStatus3, setPNlStatus3] = useState(true);
  const [brokerMarkets, setBrokerMarkets] = useState({});
  const [
    togglePortfolioPercentageForBot1,
    setTogglePortfolioPercentageForBot1,
  ] = useState("");

  const [botId, setBotId] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [botAssetPairBinance, setBotAssetPairBinance] = useState("");
  const [botExpiresInDays, setBotExpiresInDays] = useState(0);
  const [botExpiresInMin, setBotExpiresInMin] = useState(0);
  const [botExpiresInHrs, setBotExpiresInHrs] = useState(0);
  const [botActiveStatus, setBotActiveStatus] = useState(false);
  const [botStatus, setBotStatus] = useState("");
  const [fixedPricechk, setFixedCheck] = useState(false);

  const [dcaInvestingTimeDays, setDcaInvestingTimeDays] = useState(0);
  const [dcaInvestingTimeHrs, setDcaInvestingTimeHrs] = useState(0);
  const [dcaInvestingTimeMin, setDcaInvestingTimeMin] = useState(0);

  // Check for errors based on the conditions you specified
  const isFormValid = () => {
    return (
      botName === "" ||
      botDescription === "" ||
      marketName === "" ||
      botAssetPair === "" ||
      botExpireTime === "" ||
      botExpireTimeType === "" ||
      orderType === "" ||
      marketOrderTPError ||
      lmodtp1PriceErrorGrt ||
      lmodtp1PriceErrorlwr ||
      lmodtp2PriceErrorGrt ||
      lmodtp2PriceErrorlwr ||
      lmodtp3PriceErrorGrt ||
      lmodtp3PriceErrorlwr ||
      limitOrderTPError ||
      modtp1PriceErrorGrt ||
      modtp2PriceErrorGrt ||
      modtp3PriceErrorGrt ||
      modtp1PriceErrorlwr ||
      modtp2PriceErrorlwr ||
      modtp3PriceErrorlwr ||
      moSngEntErrorGrt ||
      moSngEntErrorlwr ||
      selectedApiKeyMulti?.api_key === "" ||
      BinanceBalanceCheckStatus ||
      (orderType === "Market Order" && botType === "") ||
      (botType === "Single Entry" &&
        (marketPriceReachForBot1 === "" || positionSizeForBot1 === ""))
    );
  };

  console.log("isFormValid", moSngEntErrorGrt, moSngEntErrorlwr);

  const ltpValidation = () => {
    if (
      moSngEntErrorGrt ||
      moSngEntErrorlwr ||
      lmodtp1PriceErrorGrt ||
      lmodtp1PriceErrorlwr ||
      lmodtp2PriceErrorGrt ||
      lmodtp2PriceErrorlwr ||
      lmodtp3PriceErrorGrt ||
      lmodtp3PriceErrorlwr ||
      modtp1PriceErrorGrt ||
      modtp1PriceErrorlwr ||
      modtp2PriceErrorGrt ||
      modtp2PriceErrorlwr
    ) {
      return true;
    }
  };

  const isValid = () => {
    if (
      botName === "" ||
      botDescription === "" ||
      marketName === "" ||
      botAssetPair === "" ||
      botExpireTime === "" ||
      botExpireTimeType === "" ||
      orderType === "" ||
      selectedApiKeyMulti?.api_key === "" ||
      marketOrderTPError ||
      limitOrderTPError
    ) {
      return false;
    }

    if (orderType === "Market Order" && botType === "") return false;

    if (
      botType === "Single Entry" &&
      (marketPriceReachTypeForSingleEntry === "" ||
        marketPriceReachForSingleEntry === "" ||
        positionSizeForSingleEntry === "")
    ) {
      return false;
    }

    if (
      botType === "Single Entry" &&
      positionSizeForSingleEntry === "Percent of Portfolio" &&
      percentageOfPortfolioForSingleEntry === ""
    ) {
      return false;
    }

    if (
      botType === "Single Entry" &&
      positionSizeForSingleEntry === "Fixed Amount" &&
      fixedAmountForSingleEntry === ""
    ) {
      return false;
    }

    if (
      botType === "Take Profit" &&
      !isProfit1CheckedForTakeProfit &&
      !isProfit2CheckedForTakeProfit &&
      !isProfit3CheckedForTakeProfit
    ) {
      return false;
    }

    if (
      botType === "Take Profit" &&
      isProfit1CheckedForTakeProfit &&
      (marketPriceReachProfit1ForTakeProfit === "" ||
        marketPriceProfit1ForTakeProfit === "" ||
        plPercentProfit1ForTakeProfit === "" ||
        portfolioPercentageProfit1ForTakeProfit1 === "")
    ) {
      return false;
    }

    if (
      botType === "Take Profit" &&
      isProfit2CheckedForTakeProfit &&
      (marketPriceReachProfit2ForTakeProfit === "" ||
        marketPriceProfit2ForTakeProfit === "" ||
        plPercentProfit2ForTakeProfit === "" ||
        portfolioPercentageProfit2ForTakeProfit1 === "")
    ) {
      return false;
    }

    if (
      botType === "Take Profit" &&
      isProfit3CheckedForTakeProfit &&
      (marketPriceReachProfit3ForTakeProfit === "" ||
        marketPriceProfit3ForTakeProfit === "" ||
        plPercentProfit3ForTakeProfit === "" ||
        portfolioPercentageProfit3ForTakeProfit1 === "")
    ) {
      return false;
    }

    if (
      botType === "Dollar Cost Average" &&
      (positionSizeForDollarCostAverage === "" ||
        investTimeForDolarCostAverage === "" ||
        investTimeForDolarCostAverageType === "")
    ) {
      return false;
    }

    if (
      botType === "Dollar Cost Average" &&
      positionSizeForDollarCostAverage === "Percent of Portfolio" &&
      percentageOfPortfolioForDollarCostAverage === ""
    ) {
      return false;
    }

    if (
      botType === "Dollar Cost Average" &&
      positionSizeForDollarCostAverage === "Fixed Amount" &&
      fixedAmountForDollarCostAverage === ""
    ) {
      return false;
    }

    // LIMIT ORDER conditions
    if (
      orderType === "Limit Order" &&
      !isProfit1Checked &&
      !isProfit2Checked &&
      !isProfit3Checked
    ) {
      return false;
    }

    if (
      orderType === "Limit Order" &&
      isProfit1Checked &&
      (marketPriceReachForBotType === "" ||
        marketPriceReachForBot1 === "" ||
        deviationFromForBot1 === "" ||
        deviationPercentageForBot1 === "" ||
        positionSizeForBot1 === "")
    ) {
      return false;
    }

    if (
      orderType === "Limit Order" &&
      positionSizeForBot1 === "Percent of Portfolio" &&
      percentageOfPortfolioForBot1 === ""
    ) {
      return false;
    }

    if (
      orderType === "Limit Order" &&
      positionSizeForBot1 === "Fixed Amount" &&
      fixedAmountForBot1 === ""
    ) {
      return false;
    }

    if (
      orderType === "Limit Order" &&
      isProfit2Checked &&
      (marketPriceReachForBotType === "" ||
        marketPriceReachForBot2 === "" ||
        deviationFromForBot2 === "" ||
        deviationPercentageForBot2 === "" ||
        positionSizeForBot2 === "")
    ) {
      return false;
    }

    if (
      orderType === "Limit Order" &&
      positionSizeForBot2 === "Percent of Portfolio" &&
      percentageOfPortfolioForBot2 === ""
    ) {
      return false;
    }

    if (
      orderType === "Limit Order" &&
      positionSizeForBot2 === "Fixed Amount" &&
      fixedAmountForBot2 === ""
    ) {
      return false;
    }

    if (
      orderType === "Limit Order" &&
      isProfit3Checked &&
      (marketPriceReachForBotType === "" ||
        marketPriceReachForBot3 === "" ||
        deviationFromForBot3 === "" ||
        deviationPercentageForBot3 === "" ||
        positionSizeForBot3 === "")
    ) {
      return false;
    }

    if (
      orderType === "Limit Order" &&
      positionSizeForBot3 === "Percent of Portfolio" &&
      percentageOfPortfolioForBot3 === ""
    ) {
      return false;
    }

    if (
      orderType === "Limit Order" &&
      positionSizeForBot3 === "Fixed Amount" &&
      fixedAmountForBot3 === ""
    ) {
      return false;
    }

    return true;
  };

  console.log("selectedApiKeyMulti", selectedApiKeyMulti);

  const createBotApiCall = async () => {
    const createBot = {};

    createBot["botId"] = "";

    createBot["customerId"] = localStorage.getItem("userId");
    createBot["botName"] = botName;
    createBot["botDescription"] = botDescription;
    createBot["botMarketType"] = marketName;
    createBot["apiKeyId"] = selectedApiKeyMulti?.apiKeyId;
    createBot["botAssetPair"] = finalBotAssetPair;
    createBot["botTradeOrder"] = botOrder;
    createBot["botOrderType"] = orderType;
    createBot["botType"] = botType;

    if (marketName === "OPTIONS") {
      marginType = 2;
    }

    createBot["botMarginType"] = marginType;
    createBot["botLeverage"] = leverage;

    if (botExpireTime === null || botExpireTime === "") {
      setBotExpireTime("0");
    }

    if (botExpireTimeType === "days") {
      createBot["botExpiresInDays"] = parseInt(botExpireTime);
      createBot["botExpiresInMin"] = "";
      createBot["botExpiresInHour"] = "";
      createBot["expiration_flag"] = "D";
    } else if (botExpireTimeType === "hrs") {
      createBot["botExpiresInDays"] = "";
      createBot["botExpiresInMin"] = "";
      createBot["botExpiresInHour"] = parseInt(botExpireTime);
      createBot["expiration_flag"] = "H";
    } else if (botExpireTimeType === "min") {
      createBot["botExpiresInDays"] = "";
      createBot["botExpiresInMin"] = parseInt(botExpireTime);
      createBot["botExpiresInHour"] = "";
      createBot["expiration_flag"] = "M";
    }

    createBot["botIsActive"] = 1;
    createBot["status"] = 0;
    createBot["id"] = 0;

    // TP1
    createBot["lobTp1MarketDirection"] = marketPriceReachForBotType;
    createBot["lobTp1PriceEntered"] = parseFloat(marketPriceReachForBot1);
    createBot["lobTp1DeviationFrom"] = deviationFromForBot1;
    createBot["lobTp1DeviationPer"] = parseFloat(deviationPercentageForBot1);
    createBot["lobTp1PositionSize"] = positionSizeForBot1;

    if (positionSizeForBot1 === "Percent of Portfolio") {
      createBot["lobTp1PerOfPortfolio"] = parseFloat(
        percentageOfPortfolioForBot1
      );
      createBot["lobTp1FixedAmount"] = 0;
    } else {
      createBot["lobTp1PerOfPortfolio"] = 0;
      createBot["lobTp1FixedAmount"] = parseFloat(fixedAmountForBot1);
    }

    // TP2
    createBot["lobTp2MarketDirection"] = marketPriceReachForBot2Type;
    createBot["lobTp2PriceEntered"] = parseFloat(marketPriceReachForBot2);
    createBot["lobTp2DeviationFrom"] = deviationFromForBot2;
    createBot["lobTp2DeviationPer"] = parseFloat(deviationPercentageForBot2);
    createBot["lobTp2PositionSize"] = positionSizeForBot2;

    if (positionSizeForBot2 === "Percent of Portfolio") {
      createBot["lobTp2PerOfPortfolio"] = parseFloat(
        percentageOfPortfolioForBot2
      );
      createBot["lobTp2FixedAmount"] = 0;
    } else {
      createBot["lobTp2PerOfPortfolio"] = 0;
      createBot["lobTp2FixedAmount"] = parseFloat(fixedAmountForBot2);
    }

    // TP3
    createBot["lobTp3MarketDirection"] = marketPriceReachForBot3Type;
    createBot["lobTp3PriceEntered"] = parseFloat(marketPriceReachForBot3);
    createBot["lobTp3DeviationFrom"] = deviationFromForBot3;
    createBot["lobTp3DeviationPer"] = parseFloat(deviationPercentageForBot3);
    createBot["lobTp3PositionSize"] = positionSizeForBot3;

    if (positionSizeForBot3 === "Percent of Portfolio") {
      createBot["lobTp3PerOfPortfolio"] = parseFloat(
        percentageOfPortfolioForBot3
      );
      createBot["lobTp3FixedAmount"] = 0;
    } else {
      createBot["lobTp3PerOfPortfolio"] = 0;
      createBot["lobTp3FixedAmount"] = parseFloat(fixedAmountForBot3);
    }

    // Single Entry
    createBot["semoMarketDirection"] = marketPriceReachTypeForSingleEntry;
    createBot["semoPriceEntered"] = parseFloat(marketPriceReachForSingleEntry);
    createBot["semoPositionSize"] = positionSizeForSingleEntry;

    if (positionSizeForSingleEntry === "Percent of Portfolio") {
      createBot["semoPerOfPortfolio"] = parseFloat(
        percentageOfPortfolioForSingleEntry
      );
      createBot["semoFixedAmount"] = 0;
    } else {
      createBot["semoPerOfPortfolio"] = 0;
      createBot["semoFixedAmount"] = parseFloat(fixedAmountForSingleEntry);
    }

    // TP Market Order 1
    createBot["tpmoTp1MarketDirection"] = marketPriceReachProfit1ForTakeProfit;
    createBot["tpmoTp1PriceEntered"] = parseFloat(
      marketPriceProfit1ForTakeProfit
    );
    createBot["tpmoTp1Pnl"] = pNlStatus
      ? -parseFloat(plPercentProfit1ForTakeProfit)
      : parseFloat(plPercentProfit1ForTakeProfit);
    createBot["tpmoTp1PerOfPortfolio"] = parseFloat(
      portfolioPercentageProfit1ForTakeProfit1
    );

    // TP Market Order 2
    createBot["tpmoTp2MarketDirection"] = marketPriceReachProfit2ForTakeProfit;
    createBot["tpmoTp2PriceEntered"] = parseFloat(
      marketPriceProfit2ForTakeProfit
    );
    createBot["tpmoTp2Pnl"] = pNlStatus2
      ? -parseFloat(plPercentProfit2ForTakeProfit)
      : parseFloat(plPercentProfit2ForTakeProfit);
    createBot["tpmoTp2PerOfPortfolio"] = parseFloat(
      portfolioPercentageProfit2ForTakeProfit1
    );

    // TP Market Order 3
    createBot["tpmoTp3MarketDirection"] = marketPriceReachProfit3ForTakeProfit;
    createBot["tpmoTp3PriceEntered"] = parseFloat(
      marketPriceProfit3ForTakeProfit
    );
    createBot["tpmoTp3Pnl"] = pNlStatus3
      ? -parseFloat(plPercentProfit3ForTakeProfit)
      : parseFloat(plPercentProfit3ForTakeProfit);
    createBot["tpmoTp3PerOfPortfolio"] = parseFloat(
      portfolioPercentageProfit3ForTakeProfit1
    );

    // Dollar Cost Averaging
    createBot["dcaPositionSize"] = positionSizeForDollarCostAverage;
    createBot["dcaPerOfPortfolio"] = parseFloat(
      percentageOfPortfolioForDollarCostAverage
    );
    createBot["dcaFixedAmount"] = parseFloat(fixedAmountForDollarCostAverage);

    if (investTimeForDolarCostAverageType === "days") {
      createBot["dcaInvestingTimeMin"] = 0;
      createBot["dcaInvestingTimeHrs"] = 0;
      createBot["dcaInvestingTimeDays"] = parseInt(
        investTimeForDolarCostAverage
      );
    } else if (investTimeForDolarCostAverageType === "hrs") {
      createBot["dcaInvestingTimeMin"] = 0;
      createBot["dcaInvestingTimeHrs"] = parseInt(
        investTimeForDolarCostAverage
      );
      createBot["dcaInvestingTimeDays"] = 0;
    } else if (investTimeForDolarCostAverageType === "mins") {
      createBot["dcaInvestingTimeMin"] = parseInt(
        investTimeForDolarCostAverage
      );
      createBot["dcaInvestingTimeHrs"] = 0;
      createBot["dcaInvestingTimeDays"] = 0;
    }

    createBot["exchange_name"] = exchangeName;
    createBot["currency"] = showAsset;

    if (exchangeName === "BINANCE" || exchangeName === "PAYBITO") {
      createBot["marketPrice"] = ltpData;
      createBot["api_key"] = selectedApiKeyMulti?.api_key;
      createBot["secret_key"] = selectedApiKeyMulti?.secret_key;
    } else {
      createBot["api_key"] = "";
      createBot["secret_key"] = "";
    }

    createBot["action"] = "INSERT";

    const jsonString = JSON.stringify(createBot);

    try {
      const res = await fetch(`${COPYTRADINGSERVICE}/bot/CreateNewBot`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
        body: jsonString,
      });

      const response = await res.json();

      if (response.error.error_data === 0) {
        showToast("success", response.error.error_msg); // replace with toast if needed
        navigate("/my-bots");
      } else {
        showToast("error", response.error.error_msg); // replace with error toast if needed
      }
    } catch (error) {
      console.error("Bot creation failed", error);
      showToast("error", "Something went wrong while creating the bot.");
    }
  };
  // Event handlers for different input changes

  const handlePercentageChange = (event) => {
    percentageValidation(
      event.target.value,
      "percentageOfPortfolioForDollarCostAverage"
    );
    singeEntryBinanceFixedPriceCheck(
      "",
      "",
      "MARKET",
      "PF",
      event.target.value,
      "",
      ""
    );
    paybitoMarketOrderPriceCheck(
      "",
      "Market Order",
      "Percent of Portfolio",
      event.target.value,
      ""
    );
  };
  const handleFixedAmountChange = (e) => {
    const value = e.target.value;

    // Allow only numeric input with optional decimal
    const numericValue = value.replace(/[^0-9.]/g, "");
    if (FixedPriceChk(numericValue)) {
      setFixedAmountForDollarCostAverage(numericValue);

      // Equivalent to (ngModelChange)
      singeEntryBinanceFixedPriceCheck(
        numericValue,
        "",
        "MARKET",
        "FA",
        "",
        "",
        ""
      );
      paybitoMarketOrderPriceCheck(
        numericValue,
        "Market Order",
        "Fixed Amount",
        "",
        ""
      );
    }
  };

  const handleBlurFixedAmountChange = () => {
    // Equivalent to (change)
    fixedAmountminmaxCheck(
      fixedAmountForDollarCostAverage,
      "fixedAmountForDollarCostAverage"
    );
    paybitoMarketOrderPriceCheck(
      fixedAmountForDollarCostAverage,
      "Market Order",
      "Fixed Amount",
      "",
      ""
    );
  };
  const handleInvestTimeChange = (event) => {
    if (
      !investingTimeCheck(event.target.value, investTimeForDolarCostAverageType)
    ) {
      setInvestTimeForDolarCostAverage(""); // Clear on blur if invalid
    } else {
      setInvestTimeForDolarCostAverage(event.target.value);
    }
  };

  const handleInvestTimeTypeChange = (event) => {
    setInvestTimeForDolarCostAverageType(event.target.value);
    if (
      !investingTimeCheck(investTimeForDolarCostAverage, event.target.value)
    ) {
      setInvestTimeForDolarCostAverage("");
    }
  };

  // Sample validation functions
  const percentageValidation = (value) => {
    // Your validation logic here
  };

  const priceTooltip =
    "If Above is selected, the value entered here must be greater than the current market price. If Below is selected, the value entered here must be less than the current market price.";

  const presetPercents = [10, 25, 50, 75, 100];

  useEffect(() => {
    getAllBrokerMarkets();
    getUserTransaction();
  }, []);
  useEffect(() => {
    if (botId) {
      getAssetPair();
    }
  }, [botId]);
  console.log(
    "botDetails",
    botAssetPair,
    botDetails?.botAssetPair === botAssetPair
  );
  const assignBotValue = () => {
    setBotId(botDetails["botId"]);
    setBotName(botDetails["botName"]);
    setExchangeName(botDetails["exchange_name"]);
    setApipublicKey(botDetails["api_key"]);
    setApisecretKey(botDetails["secret_key"]);
    setBotDescription(botDetails["botDescription"]);
    setMarketName(botDetails["botMarketType"]?.toUpperCase());

    // Call getAssetPair() here if needed

    setApiKey(botDetails["apiKeyId"]);
    setBotAssetPair(botDetails["botAssetPair"]);
    setBotAssetPairBinance(botDetails["botAssetPair"]);
    setBotOrder(botDetails["botTradeOrder"]);

    // Call getBinanceBalance() here if needed

    setOrderType(botDetails["botOrderType"]);
    setBotType(botDetails["botType"]);
    setLeverage(botDetails["botLeverage"] || 2);
    setMarginType(botDetails["botMarginType"]);

    // Handle expiration time
    setBotExpiresInDays(botDetails["days_left_to_expire"]);
    setBotExpiresInMin(botDetails["mins_left_to_expire"]);
    setBotExpiresInHrs(botDetails["hours_left_to_expire"]);

    if (botDetails["days_left_to_expire"] != 0) {
      setBotExpireTimeType("days");
      setBotExpireTime(botDetails["days_left_to_expire"]);
    }
    if (botDetails["mins_left_to_expire"] != 0) {
      setBotExpireTimeType("min");
      setBotExpireTime(botDetails["mins_left_to_expire"]);
    }
    if (botDetails["hours_left_to_expire"] != 0) {
      setBotExpireTimeType("hrs");
      setBotExpireTime(botDetails["hours_left_to_expire"]);
    }

    setBotActiveStatus(botDetails["botIsActive"]);
    setBotStatus(botDetails["status"]);

    // Bot type 1 values
    setMarketPriceReachForBotType(botDetails["lobTp1MarketDirection"]);
    setMarketPriceReachForBot1(botDetails["lobTp1PriceEntered"]);
    setDeviationFromForBot1(botDetails["lobTp1DeviationFrom"]);
    setDeviationPercentageForBot1(botDetails["lobTp1DeviationPer"]);
    setPositionSizeForBot1(botDetails["lobTp1PositionSize"]);
    setPercentageOfPortfolioForBot1(botDetails["lobTp1PerOfPortfolio"]);
    setFixedAmountForBot1(botDetails["lobTp1FixedAmount"]);
    setIsProfit1Checked(botDetails["lobTp1DeviationFrom"] != null);

    // Bot type 2 values
    setMarketPriceReachForBot2Type(botDetails["lobTp2MarketDirection"]);
    setMarketPriceReachForBot2(botDetails["lobTp2PriceEntered"]);
    setDeviationFromForBot2(botDetails["lobTp2DeviationFrom"]);
    setDeviationPercentageForBot2(botDetails["lobTp2DeviationPer"]);
    setPositionSizeForBot2(botDetails["lobTp2PositionSize"]);
    setPercentageOfPortfolioForBot2(botDetails["lobTp2PerOfPortfolio"]);
    setFixedAmountForBot2(botDetails["lobTp2FixedAmount"]);
    setIsProfit2Checked(botDetails["lobTp2DeviationFrom"] != null);

    // Bot type 3 values
    setMarketPriceReachForBot3Type(botDetails["lobTp3MarketDirection"]);
    setMarketPriceReachForBot3(botDetails["lobTp3PriceEntered"]);
    setDeviationFromForBot3(botDetails["lobTp3DeviationFrom"]);
    setDeviationPercentageForBot3(botDetails["lobTp3DeviationPer"]);
    setPositionSizeForBot3(botDetails["lobTp3PositionSize"]);
    setPercentageOfPortfolioForBot3(botDetails["lobTp3PerOfPortfolio"]);
    setFixedAmountForBot3(botDetails["lobTp3FixedAmount"]);
    setIsProfit3Checked(botDetails["lobTp3DeviationFrom"] != null);

    // Single Entry values
    setMarketPriceReachTypeForSingleEntry(botDetails["semoMarketDirection"]);
    setMarketPriceReachForSingleEntry(botDetails["semoPriceEntered"]);
    setPositionSizeForSingleEntry(botDetails["semoPositionSize"]);
    setPercentageOfPortfolioForSingleEntry(botDetails["semoPerOfPortfolio"]);
    setFixedAmountForSingleEntry(botDetails["semoFixedAmount"]);

    // Take Profit values - Profit 1
    setMarketPriceReachProfit1ForTakeProfit(
      botDetails["tpmoTp1MarketDirection"]
    );
    setMarketPriceProfit1ForTakeProfit(botDetails["tpmoTp1PriceEntered"]);
    setPlPercentProfit1ForTakeProfit(botDetails["tpmoTp1Pnl"]);
    setPortfolioPercentageProfit1ForTakeProfit1(
      botDetails["tpmoTp1PerOfPortfolio"]
    );
    setIsProfit1CheckedForTakeProfit(
      botDetails["tpmoTp1MarketDirection"] != null
    );

    // Take Profit values - Profit 2
    setMarketPriceReachProfit2ForTakeProfit(
      botDetails["tpmoTp2MarketDirection"]
    );
    setMarketPriceProfit2ForTakeProfit(botDetails["tpmoTp2PriceEntered"]);
    setPlPercentProfit2ForTakeProfit(botDetails["tpmoTp2Pnl"]);
    setPortfolioPercentageProfit2ForTakeProfit1(
      botDetails["tpmoTp2PerOfPortfolio"]
    );
    setIsProfit2CheckedForTakeProfit(
      botDetails["tpmoTp2MarketDirection"] != null
    );

    // Take Profit values - Profit 3
    setMarketPriceReachProfit3ForTakeProfit(
      botDetails["tpmoTp3MarketDirection"]
    );
    setMarketPriceProfit3ForTakeProfit(botDetails["tpmoTp3PriceEntered"]);
    setPlPercentProfit3ForTakeProfit(botDetails["tpmoTp3Pnl"]);
    setPortfolioPercentageProfit3ForTakeProfit1(
      botDetails["tpmoTp3PerOfPortfolio"]
    );
    setIsProfit3CheckedForTakeProfit(
      botDetails["tpmoTp3MarketDirection"] != null
    );

    // DCA values
    setPositionSizeForDollarCostAverage(botDetails["dcaPositionSize"]);
    setPercentageOfPortfolioForDollarCostAverage(
      botDetails["dcaPerOfPortfolio"]
    );
    setFixedAmountForDollarCostAverage(botDetails["dcaFixedAmount"]);

    setDcaInvestingTimeDays(botDetails["dcaInvestingTimeDays"]);
    setDcaInvestingTimeHrs(botDetails["dcaInvestingTimeHrs"]);
    setDcaInvestingTimeMin(botDetails["dcaInvestingTimeMin"]);

    if (botDetails["dcaInvestingTimeDays"] != 0) {
      setInvestTimeForDolarCostAverageType("days");
      setInvestTimeForDolarCostAverage(botDetails["dcaInvestingTimeDays"]);
    }
    if (botDetails["dcaInvestingTimeMin"] != 0) {
      setInvestTimeForDolarCostAverageType("mins");
      setInvestTimeForDolarCostAverage(botDetails["dcaInvestingTimeMin"]);
    }
    if (botDetails["dcaInvestingTimeHrs"] != 0) {
      setInvestTimeForDolarCostAverageType("hrs");
      setInvestTimeForDolarCostAverage(botDetails["dcaInvestingTimeHrs"]);
    }

    moLtpPosChkTp1();
    moLtpPosChkTp2();
    moLtpPosChkTp3();
  };

  console.log("selectedApiKeyMulti", selectedApiKeyMulti);

  useEffect(() => {
    if (botDetails) {
      assignBotValue();
    }
  }, [botDetails]);

  const handlePositionSizeChange = (val) => {
    console.log("handlePositionSizeChange", val);
    setPositionSizeForDollarCostAverage(val);
  };

  const handleBotSelection = (botName, e) => {
    const checked = e.target.checked;

    if (botName === "profit1") {
      setIsProfit1Checked(checked);
      setDeviationPercentageForBot1("");
      setMarketPriceReachForBotType("");
      setMarketPriceReachForBot1("");
      setDeviationFromForBot1("");
      setPositionSizeForBot1("");
      setPercentageOfPortfolioForBot1("");
      setFixedAmountForBot1("");
      validateLimitOrderTPValue(
        "",
        deviationPercentageForBot2,

        deviationPercentageForBot3
      );
    } else if (botName === "profit2") {
      setIsProfit2Checked(checked);
      setDeviationPercentageForBot2("");
      setMarketPriceReachForBot2Type("");
      setMarketPriceReachForBot2("");
      setDeviationFromForBot2("");
      setPositionSizeForBot2("");
      setPercentageOfPortfolioForBot2("");
      setFixedAmountForBot2("");
      validateLimitOrderTPValue(
        deviationPercentageForBot1,
        "",

        deviationPercentageForBot3
      );
    } else if (botName === "profit3") {
      setIsProfit3Checked(checked);
      setDeviationPercentageForBot3("");
      setMarketPriceReachForBot3Type("");
      setMarketPriceReachForBot3("");
      setDeviationFromForBot3("");
      setPositionSizeForBot3("");
      setPercentageOfPortfolioForBot3("");
      setFixedAmountForBot3("");
      validateLimitOrderTPValue(
        deviationPercentageForBot1,
        deviationPercentageForBot2,

        ""
      );
    } else if (botName === "profit1ForTakeProfit") {
      setIsProfit1CheckedForTakeProfit(checked);
      setPortfolioPercentageProfit1ForTakeProfit1("");
      setMarketPriceReachProfit1ForTakeProfit(checked ? "above" : "");
      setMarketPriceProfit1ForTakeProfit("");
      setPlPercentProfit1ForTakeProfit("");
      validateMarketOrderTPValue(
        "",
        portfolioPercentageProfit2ForTakeProfit1,
        portfolioPercentageProfit3ForTakeProfit1
      );
    } else if (botName === "profit2ForTakeProfit") {
      setIsProfit2CheckedForTakeProfit(checked);
      setPortfolioPercentageProfit2ForTakeProfit1("");
      setMarketPriceReachProfit2ForTakeProfit(checked ? "above" : "");
      setMarketPriceProfit2ForTakeProfit("");
      setPlPercentProfit2ForTakeProfit("");
      validateMarketOrderTPValue(
        portfolioPercentageProfit1ForTakeProfit1,
        "",
        portfolioPercentageProfit3ForTakeProfit1
      );
    } else if (botName === "profit3ForTakeProfit") {
      setIsProfit3CheckedForTakeProfit(checked);
      setPortfolioPercentageProfit3ForTakeProfit1("");
      setMarketPriceReachProfit3ForTakeProfit(checked ? "above" : "");
      setMarketPriceProfit3ForTakeProfit("");
      setPlPercentProfit3ForTakeProfit("");
      validateMarketOrderTPValue(
        portfolioPercentageProfit1ForTakeProfit1,
        portfolioPercentageProfit2ForTakeProfit1,
        ""
      );
    }
  };
  const handleBot2Selection = () => {
    setIsProfit2Checked(!isProfit2Checked);
  };

  const lmodtp1PriceChk = (val, val2) => {
    if (!val) return;
    const price = parseFloat(val);
    const ltp = Number(ltpData);
    setLmodtp1PriceErrorGrt(false);
    setLmodtp1PriceErrorlwr(false);
    if (val2 === "above" && price <= ltp) {
      setLmodtp1PriceErrorGrt(true);
      setLmodtp1PriceErrorlwr(false);
    } else if (val2 === "below" && price >= ltp) {
      setLmodtp1PriceErrorlwr(true);
      setLmodtp1PriceErrorGrt(false);
    } else {
      setLmodtp1PriceErrorGrt(false);
      setLmodtp1PriceErrorlwr(false);
    }
  };

  const handleOrderTypeChange = (event) => {
    setOrderType(event.target.value);
    resetLimitOrderType();
  };

  const handleOrderChange = (event) => {
    setBotOrder(event.target.value);
    getAssetPair(marketName);
    // changeAssetPairForAssetBox();
  };

  const handlePairChange = (event) => {
    setBotAssetPair(event.target.value);
    const curSegment = event.target.value?.split("-");
    let showAssetPair = "";
    if (marketName === "SPOT") {
      showAssetPair = `${curSegment[0]}-${curSegment[1]}`;
    } else {
      showAssetPair = `${curSegment[3]}`;
    }
    setLtpData(curSegment[2]);
    setFinalBotAssetPair(showAssetPair);
    console.log("botAssetPair", event.target.value);
    if (marketName === "SPOT") filterAvailableBalance(event.target.value);
    else if (marketName === "FUTURES")
      filterAvailableBalanceFuture(event.target.value);
    else if (marketName === "OPTIONS")
      filterAvailableBalanceOptions(event.target.value);
  };

  const resetApiKey = () => {
    setSelectedApiKeyMulti();
  };

  const getAllApiKeys = (val, exchName = exchangeName) => {
    const payload = {
      customerId: parseInt(localStorage.getItem("userId")),
      marketType: val,
      exchange_name: exchName,
    };

    axios
      .post(`${COPYTRADINGSERVICE}/bot/GetApiKey`, JSON.stringify(payload), {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const result = response.data;
        if (result.error.error_data !== 0) {
          showToast("error", result.error.error_msg);
        } else {
          setSelectedApiKey(result.keyDetails || []);
        }
      })
      .catch((error) => {
        showToast("error", "Internal Server Error");
        // //logout
      });
  };

  const getAssetPair = (val, exchName = exchangeName) => {
    let payload = {};
    let marketType = 1;
    let txnType = 1;
    let leverageValue = leverage;

    if (val === "SPOT") {
      marketType = 1;
      setMarginShowStatus(false);
      setMarginType(0);
      setLeverage("");
      setMarginTypeOptionStatus(false);
      leverageValue = "";
    } else if (val === "FUTURES") {
      marketType = 2;

      if (exchName === "BINANCE") {
        setMarginShowStatus(false);
        setMarginTypeOptionStatus(false);
        leverageValue = "";
      } else {
        setMarginShowStatus(true);
        setMarginTypeOptionStatus(false);

        if (leverageValue === "") {
          leverageValue = 2;
        }
      }
    } else {
      console.log("in else");
      // setMarginType(2);
      // marketType = 3;
      // setMarginShowStatus(true);
      // setMarginTypeOptionStatus(true);

      if (leverageValue === "") {
        leverageValue = 2;
        console.log("in else 2");
      } else {
        console.log("in else 3");
      }
    }

    if (marginShowStatus === true) {
      console.log("in else 4", leverageValue);
      if (leverageValue === "") {
        leverageValue = 2;
        console.log("in else 5", leverageValue);
      } else {
        console.log("in else 6", leverageValue);
      }
    } else {
      leverageValue = "";
    }

    setLeverage(leverageValue);

    txnType = botOrder === "Buy" ? 1 : 2;

    payload = {
      marketType: marketType,
      txnType: txnType,
      isUpdate: 0,
      customerId: localStorage.getItem("userId"),
      exchange_name: exchName,
    };

    axios
      .post(
        `${COPYTRADINGSERVICE}/bot/GetAssetPairs`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      )
      .then((response) => {
        console.log("myyll", response.data.getAssetPairs);
        setAssetPairBack(response.data.getAssetPairs);
      })
      .catch((error) => {
        console.error("Error fetching asset pairs:", error);
      });

    getAllApiKeys(val, exchName);
  };

  const deviationValidationCheck = (e) => {
    const val = parseFloat(e.target.value);
    setDeviationPercentageForBot1(val);
    if (val > 50) {
      showToast("error", "Amount cannot be greater than 50");
      setDeviationPercentageForBot1("");
    }
  };
  const deviationValidationCheckBot2 = (e) => {
    const val = parseFloat(e.target.value);
    setDeviationPercentageForBot2(val);
    if (val > 50) {
      showToast("error", "Amount cannot be greater than 50");
      setDeviationPercentageForBot2("");
    }
  };
  const deviationValidationCheckBot3 = (e) => {
    const val = parseFloat(e.target.value);
    setDeviationPercentageForBot3(val);
    if (val > 50) {
      showToast("error", "Amount cannot be greater than 50");
      setDeviationPercentageForBot3("");
    }
  };

  const changeAssetPairForAssetBox = () => {
    if (marketName === "SPOT") {
      filterAvailableBalance(botAssetPair);
    } else {
      filterAvailableBalanceFuture(botAssetPair);
    }
  };

  const getUserTransaction = async () => {
    const payload = {
      customerId: localStorage.getItem("user_id"),
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast("danger", "Cannot fetch user balance");
        console.log("Fetching User balance failed");
      } else {
        const balanceList = response.data.userBalanceList;
        setCurrencyBalance(balanceList);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        // //logout
        showToast("warning", "SESSION TIMED OUT. LOGIN AGAIN");
      }
    }
  };

  const filterAvailableBalance = (val) => {
    console.log("filterAvailableBalance", val);
    let curSegment = val?.split("-");
    setBotAssetPairTrimmed(`${curSegment[0]}-${curSegment[1]}`);
    setLtpData(curSegment[2]);
    console.log("ltpData", curSegment[2]);
    let price = currencyBalance?.find(
      (element) =>
        element.currencyCode === curSegment[botOrder === "Buy" ? 1 : 0]
    );

    if (botOrder && exchangeName !== "BINANCE") {
      setSelelectedSellingAssetBalance(price.closingBalance);
    } else {
      setSelelectedSellingAssetBalance("");
    }
    if (botOrder === "Buy") {
      setShowAsset(curSegment[1]);
    } else {
      setShowAsset(curSegment[0]);
    }

    if (exchangeName === "BINANCE" || exchangeName === "PAYBITO") {
      if (marketName === "SPOT") {
        filterAvailableBalanceBinance(curSegment[botOrder === "Buy" ? 1 : 0]);
        getLtpBinanceDataFromSocket(curSegment[1], curSegment[0], botOrder);
      }
      //  else {
      //   filterAvailableBalanceBinance(curSegment[botOrder === "Buy" ? 1 : 0]);
      //   getFuturesLtpBinanceDataFromSocket(
      //     curSegment[1],
      //     curSegment[0],
      //     botOrder
      //   );
      // }
    } else {
      // setSelelectedSellingAssetBalance(price.closingBalance);
    }
  };

  const filterAvailableBalanceFuture = (val) => {
    // Reset all states
    setMarketPriceReachForBotType("");
    setLmodtp1PriceErrorGrt(false);
    setLmodtp1PriceErrorlwr(false);

    setMarketPriceReachForBot2Type("");
    setLmodtp2PriceErrorGrt(false);
    setLmodtp2PriceErrorlwr(false);

    setMarketPriceReachForBot3Type("");
    setLmodtp3PriceErrorGrt(false);
    setLmodtp3PriceErrorlwr(false);

    setMarketPriceReachForSingleEntry("");
    setMoSngEntErrorGrt(false);
    setMoSngEntErrorlwr(false);

    setMarketPriceProfit1ForTakeProfit("");
    setModtp1PriceErrorGrt(false);
    setModtp1PriceErrorlwr(false);

    setMarketPriceProfit2ForTakeProfit("");
    setModtp2PriceErrorGrt(false);
    setModtp2PriceErrorlwr(false);

    setMarketPriceProfit3ForTakeProfit("");
    setModtp3PriceErrorGrt(false);
    setModtp3PriceErrorlwr(false);

    setSelelectedSellingAssetBalance("");

    const curSegment = val.split("-");

    setBotAssetPairTrimmed(curSegment[3]);
    setShowAsset(curSegment[1]);

    if (exchangeName === "BINANCE" || exchangeName === "PAYBITO") {
      const trimmedPair = `${curSegment[0]}-${curSegment[1]}`;
      setBotAssetPairTrimmed(trimmedPair);

      filterAvailableBalanceBinance(curSegment[1]);
      getFuturesLtpBinanceDataFromSocket(
        curSegment[1],
        curSegment[0],
        botOrder.toLowerCase()
      );
    } else {
      getUserTransactionFuture(curSegment[1]);
    }
  };

  const getFuturesLtpBinanceDataFromSocket = (curr1, curr2, status) => {
    if (exchangeName !== "BINANCE") return;

    console.log("changes in future socket");

    // Attempt to disconnect existing sockets
    try {
      binanceSocket.disconnect();
    } catch {
      console.log("spot socket not connected");
    }

    try {
      futureBinance._disconnect();
    } catch {
      console.log("future socket not connected");
    }

    // Reconnect future socket
    setTimeout(() => {
      futureBinance._connect();
    }, 250);

    console.log("status", status);
    setBinanceBuySellStatus(status);

    const assetPair = curr2 + curr1;
    localStorage.setItem("binanceFutureLtpAssetPair", assetPair);

    // Subscribe to socket messages after some delay
    setTimeout(() => {
      futureBinance?.currentMessage?.subscribe((message) => {
        try {
          const pairsData = JSON.parse(message);
          console.log("parsed json", pairsData);

          const ltpAssetLocalStorage = localStorage.getItem(
            "binanceFutureLtpAssetPair"
          );
          console.log("ltpAssetLocalStorageFuture", ltpAssetLocalStorage);

          if (pairsData.symbol === ltpAssetLocalStorage) {
            if (binanceBuySellStatus === "Buy") {
              console.log("in buy");
              BinanceLtpDataForPair.current = pairsData.askprice;
              setLtpData(pairsData.askprice);
            } else {
              console.log("in sell");
              BinanceLtpDataForPair.current = pairsData.bidprice;
              setLtpData(pairsData.bidprice);
            }
          }
        } catch {
          console.log("json error");
        }
      });
    }, 2000);
  };

  console.log("ltpData", ltpData);
  const getLtpBinanceDataFromSocket = (curr1, curr2, status) => {
    if (exchangeName !== "BINANCE") return;

    console.log("changes in future socket");

    // setLtpData("");

    // Attempt to disconnect existing sockets
    try {
      binanceSocket.disconnect();
    } catch {
      console.log("spot socket not connected");
    }

    try {
      futureBinance._disconnect();
    } catch {
      console.log("future socket not connected");
    }
    console.log("binanceSocket", binanceSocket);
    // Reconnect future socket
    setTimeout(() => {
      binanceSocket.connect();
    }, 250);

    console.log("status", status);
    setBinanceBuySellStatus(status);

    const assetPair = curr2 + curr1;
    localStorage.setItem("binanceFutureLtpAssetPair", assetPair);

    // Subscribe to socket messages after some delay
    setTimeout(() => {
      binanceSocket.currentMessage.subscribe((message) => {
        try {
          const pairsData = JSON.parse(message);
          console.log("parsed json", pairsData);

          const ltpAssetLocalStorage = localStorage.getItem(
            "binanceFutureLtpAssetPair"
          );

          if (pairsData.symbol === ltpAssetLocalStorage) {
            if (binanceBuySellStatus === "Buy") {
              BinanceLtpDataForPair.current = pairsData.askprice;
              setLtpData(pairsData.askprice);
            } else {
              BinanceLtpDataForPair.current = pairsData.bidprice;
              setLtpData(pairsData.bidprice);
            }
          }
        } catch {
          console.log("json error");
        }
      });
    }, 2000);
  };

  const getUserTransactionFuture = async (cur) => {
    const userTransObj = {
      customerId: localStorage.getItem("userId"),
      uuid: localStorage.getItem("uuid"),
    };

    if (selectedMarginType !== undefined && selectedMarginType !== null) {
      userTransObj["marginType"] = selectedMarginType;
    }

    try {
      const response = await axios.get(
        `${FUTURELENDINGURL}getMarginWalletByCurrency`,
        {
          params: {
            uuid: localStorage.getItem("uuid"),
            currencyName: cur,
            marginType: marginType,
            leverage: leverage || 2,
          },
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;
      setBalanceList(result.availableBalance);
      setSelectedSellingAssetBalance(result.availableBalance);
    } catch (error) {
      console.error("Error fetching future wallet:", error);
    }
  };

  const filterAvailableBalanceBinance = async (pair) => {
    console.log("bbbbvvvvvd", pair);
    const token = localStorage.getItem("access_token");
    const headers = {
      "Content-Type": "application/json",
      authorization: `BEARER ${token}`,
    };

    try {
      if (marketName === "SPOT") {
        const payload = {
          apikey: selectedApiKeyMulti?.api_key,
          secretkey: selectedApiKeyMulti?.secret_key,
          exchange_name: exchangeName,
        };

        const response = await axios.post(
          `${COPYTRADINGSERVICE}/apiKey/getBalances`,
          JSON.stringify(payload),
          { headers }
        );
        if (response) {
          const price = response?.data?.find(
            (element) => element.asset === pair
          );
          if (price) {
            setSelelectedSellingAssetBalance(price.free);
            console.log("balance", price.free);
          }
        }
      } else {
        let payload = {};
        if (exchangeName === "BINANCE") {
          payload = {
            apikey: selectedApiKeyMulti?.api_key,
            secretkey: selectedApiKeyMulti?.secret_key,
            exchange_name: exchangeName,
          };
        } else {
          payload = {
            apikey: selectedApiKeyMulti?.api_key,
            secretkey: selectedApiKeyMulti?.secret_key,
            exchange_name: exchangeName,
            marginType: parseInt(marginType),
            leverage: leverage,
          };
        }

        const response = await axios.post(
          `${COPYTRADINGSERVICE}/apiKey/getBalancesForFutures`,
          JSON.stringify(payload),
          { headers }
        );

        console.log("balance daa", pair, response.data);

        if (exchangeName === "BINANCE") {
          setSelectedSellingAssetBalance(response.data.marginBalance);
          console.log("balance", response.data.marginBalance);
        } else {
          const dataFiltered = response.data.values.filter(
            (x) => x.currencyName === pair
          );
          if (dataFiltered.length === 0) {
            setSelelectedSellingAssetBalance(0);
            setSelelectedSellingAssetBalance(0);
          } else {
            console.log("dataFiltered", dataFiltered);
            setSelectedSellingAssetBalance(dataFiltered[0].availableBalance);
            setSelelectedSellingAssetBalance(dataFiltered[0].availableBalance);
          }

          console.log("balance", selectedSellingAssetBalance);
        }
      }
    } catch (error) {
      console.error("Error fetching balance:", error);
    }
  };

  console.log("selectedSellingAssetBalance", selectedSellingAssetBalance);

  const investingTimeCheck = (val, type) => {
    if (val === 0) {
      showToast("error", "Field value cannot be 0");
      return false;
    } else if (type === "min") {
      if (val <= 0 || val > 59) {
        showToast(
          "error",
          "Field value must be greater than 0 and less than 60."
        );
        return false;
      }
    } else if (type === "hrs") {
      if (val <= 0 || val > 23) {
        showToast(
          "error",
          "Field value must be greater than 0 and less than 24."
        );
        return false;
      }
    } else if (type === "days") {
      if (String(val).length > 8) {
        showToast("error", "Days field must not exceed 8 digits.");
        return false;
      }
    }
    return true;
  };

  const changeMarginType = (type) => {
    if (type === "SPOT") {
      // Handle SPOT logic
    } else if (type === "FUTURES") {
      filterAvailableBalanceFuture(botAssetPair);
    } else {
      filterAvailableBalanceOptions(botAssetPair);
    }
  };

  const filterAvailableBalanceOptions = (val) => {
    getUserTransactionOptions();

    const curSegment = val.split("-");

    if (curSegment.length >= 7) {
      const trimmed = `${curSegment[0]}-${curSegment[1]}-${curSegment[2]}-${curSegment[3]}`;
      setBotAssetPairTrimmed(trimmed);

      // setLtpData(curSegment[6]);
      const assetCode = curSegment[5];
      setShowAsset(assetCode);
    }
  };

  const getUserTransactionOptions = () => {
    const customerId = localStorage.getItem("userId");
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    const userTransObj = {
      customerId,
      uuid,
    };

    if (selectedMarginType !== undefined && selectedMarginType !== null) {
      userTransObj.marginType = selectedMarginType;
    }

    axios
      .get(`${OPTIONSLENDINGURL}getMarginWalletByCurrency`, {
        params: {
          uuid,
          currencyName: "USDT",
          marginType: marginType,
          leverage: leverage || 2,
        },
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${accessToken}`,
        },
      })
      .then((response) => {
        const result = response.data;
        setBalanceList(result.availableBalance);
        setSelectedSellingAssetBalance(result.availableBalance);
      })
      .catch((error) => {
        console.error("Error fetching user transaction options:", error);
      });
  };

  const leverageCheck = () => {
    let updatedLeverage = leverage;

    if (updatedLeverage < 2) {
      updatedLeverage = 2;
    }
    if (updatedLeverage > 125) {
      updatedLeverage = 125;
    }

    setLeverage(updatedLeverage);
  };

  const handleExchangeChange = (event) => {
    const nextExchange = event.target.value;
    setExchangeName(nextExchange);
    getAssetPair(marketName, nextExchange);
    resetApiKey();
  };

  const VALIDATION1 = (e) => {
    const regex = /^[ A-Za-z0-9_./,-]*$/;
    const str = String.fromCharCode(!e.charCode ? e.which : e.charCode);

    if ([">", ":", ";", "<"].includes(str)) {
      e.preventDefault();
      return false;
    }

    if (!regex.test(str)) {
      e.preventDefault();
      return false;
    }

    return true;
  };

  const getAllBrokerMarkets = async () => {
    const BROKERID = localStorage.getItem("BROKERID");
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    const inputObj = { brokerId: BROKERID, uuid: uuid };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/brokerCryptoMarket`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      setBrokerMarkets(response.data.brokerCryptoMarket);
    } catch (error) {
      console.error("Error fetching broker markets:", error);
    }
  };

  const onItemSelect = (item) => {
    if (selectedApiKeyMulti.length > 0) {
      setApipublicKey(selectedApiKeyMulti[0].api_key);
      setApisecretKey(selectedApiKeyMulti[0].secret_key);
      const ids = selectedApiKeyMulti.map((api) => api.apiKeyId.toString());
      setMultiAPIId(ids);

      const idString = ids.join(",");
      setMultiIdString(idString);
    }
  };

  const onItemDeSelect = (item) => {
    const ids = selectedApiKeyMulti.map((api) => api.apiKeyId.toString());
    setMultiAPIId(ids);

    const idString = ids.join(",");
    setMultiIdString(idString);

    setApipublicKey("");
    setApisecretKey("");
  };

  const onSelectAll = (items) => {
    const ids = selectedApiKeyMulti.map((item) => item.apiKeyId.toString());
    setMultiAPIId(ids);
    const idString = ids.join(",");
    setMultiIdString(idString);
  };

  const onDeSelectAll = (items) => {
    const ids = selectedApiKeyMulti.map((item) => item.apiKeyId.toString());
    setMultiAPIId(ids);
    const idString = ids.join(",");
    setMultiIdString(idString);
    setApipublicKey("");
    setApisecretKey("");
  };

  const resetLimitOrderType = () => {
    setBinanceBalanceCheckStatus(false);
    setBotType("");
    setMarketPriceReachForBotType("");

    setMarketPriceReachForBot1("");
    setDeviationFromForBot1("");
    setDeviationPercentageForBot1("");
    setPositionSizeForBot1("");
    setPercentageOfPortfolioForBot1("");
    setFixedAmountForBot1("");

    setMarketPriceReachForBot2("");
    setDeviationFromForBot2("");
    setDeviationPercentageForBot2("");
    setPositionSizeForBot2("");
    setPercentageOfPortfolioForBot2("");
    setFixedAmountForBot2("");

    setMarketPriceReachForBot3("");
    setDeviationFromForBot3("");
    setDeviationPercentageForBot3("");
    setPositionSizeForBot3("");
    setPercentageOfPortfolioForBot3("");
    setFixedAmountForBot3("");

    setMarketPriceReachTypeForSingleEntry("");
    setMarketPriceReachForSingleEntry("");
    setPositionSizeForSingleEntry("");
    setPercentageOfPortfolioForSingleEntry("");
    setFixedAmountForSingleEntry("");

    setPositionSizeForDollarCostAverage("");
    setPercentageOfPortfolioForDollarCostAverage("");
    setFixedAmountForDollarCostAverage("");
    setInvestTimeForDolarCostAverage("");
    setInvestTimeForDolarCostAverageType("");

    setMarketPriceReachProfit1ForTakeProfit("");
    setMarketPriceProfit1ForTakeProfit("");
    setPlPercentProfit1ForTakeProfit("");
    setPortfolioPercentageProfit1ForTakeProfit1("");

    setMarketPriceReachProfit2ForTakeProfit("");
    setMarketPriceProfit2ForTakeProfit("");
    setPlPercentProfit2ForTakeProfit("");
    setPortfolioPercentageProfit2ForTakeProfit1("");

    setMarketPriceReachProfit3ForTakeProfit("");
    setMarketPriceProfit3ForTakeProfit("");
    setPlPercentProfit3ForTakeProfit("");
    setPortfolioPercentageProfit3ForTakeProfit1("");

    setIsProfit1CheckedForTakeProfit(false);
    setIsProfit2CheckedForTakeProfit(false);
    setIsProfit3CheckedForTakeProfit(false);

    setIsProfit1Checked(false);
    setIsProfit2Checked(false);
    setIsProfit3Checked(false);
  };

  const handleChange = (val) => {
    console.log("handleChange", val);
    const value = val;
    setTogglePercentageForBot1(value);
    onItemChange(value);
    validateLimitOrderTPValue(
      deviationPercentageForBot1,
      deviationPercentageForBot2,
      deviationPercentageForBot3
    );
  };

  const onItemChange = (val) => {
    setDeviationPercentageForBot1(val); // this is the equivalent of your Angular function
  };

  const validateLimitOrderTPValue = (val1, val2, val3) => {
    console.log("validateLimitOrderTPValue", val1, val2, val3);
    let tp1 = val1.replace("%", "");
    let tp2 = val2.replace("%", "");
    let tp3 = val3.replace("%", "");

    console.log("string", tp1, tp2, tp3);

    tp1 = tp1 === "" ? "0" : tp1;
    tp2 = tp2 === "" ? "0" : tp2;
    tp3 = tp3 === "" ? "0" : tp3;

    let tp1Int = parseInt(tp1, 10);
    let tp2Int = parseInt(tp2, 10);
    let tp3Int = parseInt(tp3, 10);

    tp1Int = Number.isNaN(tp1Int) ? 0 : tp1Int;
    tp2Int = Number.isNaN(tp2Int) ? 0 : tp2Int;
    tp3Int = Number.isNaN(tp3Int) ? 0 : tp3Int;

    console.log("int", tp1Int, tp2Int, tp3Int);

    const total = tp1Int + tp2Int + tp3Int;

    if (total > 100) {
      setLimitOrderTPError(true);
    } else {
      setLimitOrderTPError(false);
    }
  };

  const binanceLimitOrderPriceCheck = (
    amount,
    percent,
    orderType,
    position,
    positionPercent,
    previousPercent1,
    previousPercent2,
    previousPercent3,
    previouesFAmount1,
    previouesFAmount2,
    previouesFAmount3
  ) => {
    if (exchangeName === "BINANCE" || exchangeName === "PAYBITO") {
      // Handle empty values for amounts and percentages
      const prevAmount1 =
        previouesFAmount1 === "" ? 0 : parseFloat(previouesFAmount1);
      const prevAmount2 =
        previouesFAmount2 === "" ? 0 : parseFloat(previouesFAmount2);
      const prevAmount3 =
        previouesFAmount3 === "" ? 0 : parseFloat(previouesFAmount3);
      const prevPercent1 =
        previousPercent1 === "" ? 0 : parseFloat(previousPercent1);
      const prevPercent2 =
        previousPercent2 === "" ? 0 : parseFloat(previousPercent2);
      const prevPercent3 =
        previousPercent3 === "" ? 0 : parseFloat(previousPercent3);

      const totalPrevAmount = prevAmount1 + prevAmount2 + prevAmount3;
      const totalPrevPercent = prevPercent1 + prevPercent2 + prevPercent3;

      // const trimmedPercent = percent.replace("%", "");
      const trimmedPercent = percent;

      let payload = {};

      if (exchangeName === "PAYBITO" && marketName === "FUTURES") {
        payload = {
          symbol: botAssetPairTrimmed,
          side: botOrder,
          exchange: exchangeName,
          market: marketName,
          amount: amount,
          percent: trimmedPercent,
          orderType: orderType,
          apiKey: apipublicKey,
          secretKey: apisecretKey,
          currency: showAsset,
          position: position,
          positionPercent: positionPercent,
          previouesFAmount: totalPrevAmount,
          previousPercent: totalPrevPercent,
          marginType: parseInt(marginType),
          leverage: leverage,
        };
      } else {
        payload = {
          symbol: botAssetPairTrimmed,
          side: botOrder,
          exchange: exchangeName,
          market: marketName,
          amount: selelectedSellingAssetBalance,
          percent: trimmedPercent,
          orderType: orderType,
          apiKey: apipublicKey,
          secretKey: apisecretKey,
          currency: showAsset,
          position: position,
          positionPercent: positionPercent,
          previouesFAmount: totalPrevAmount,
          previousPercent: totalPrevPercent,
        };
      }

      console.log("Payload:", payload);

      axios
        .post(
          `${COPYTRADINGSERVICE}/bot/checkAmountForOther`,
          JSON.stringify(payload),
          {
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + localStorage.getItem("access_token"),
            },
          }
        )
        .then((response) => {
          const result = response.data;

          console.log("Result:", result);

          if (result.statusCode === "1") {
            setBinanceBalanceCheckStatus(false);
            showToast("success", result.message);
          } else {
            setBinanceBalanceCheckStatus(true);

            if (result.message) {
              showToast("error", result.message || "Null");
            }
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setBinanceBalanceCheckStatus(true);
          showToast(
            "error",
            "An error occurred while checking the order price."
          );
        });
    }
  };

  const paybitoLimitOrderPriceCheck = (
    positionSize,
    orderType,
    fixedAmount1,
    fixedAmount2,
    fixedAmount3,
    percentValue1,
    percentValue2,
    percentValue3,
    deviationPercent
  ) => {
    if (exchangeName === "YACRYPTO") {
      // Default empty strings to zero
      const parsedPercentValue1 =
        percentValue1 === "" ? 0 : parseFloat(percentValue1);
      const parsedPercentValue2 =
        percentValue2 === "" ? 0 : parseFloat(percentValue2);
      const parsedPercentValue3 =
        percentValue3 === "" ? 0 : parseFloat(percentValue3);
      const parsedFixedAmount1 =
        fixedAmount1 === "" ? 0 : parseFloat(fixedAmount1);
      const parsedFixedAmount2 =
        fixedAmount2 === "" ? 0 : parseFloat(fixedAmount2);
      const parsedFixedAmount3 =
        fixedAmount3 === "" ? 0 : parseFloat(fixedAmount3);

      const fixedAmount =
        parsedFixedAmount1 + parsedFixedAmount2 + parsedFixedAmount3;
      const percentValue =
        parsedPercentValue1 + parsedPercentValue2 + parsedPercentValue3;
      const trimmedPercent = deviationPercent.replace("%", "");

      const payload = {
        symbol: botAssetPairTrimmed,
        order: botOrder,
        market: marketName,
        orderType: orderType,
        customerId: parseInt(localStorage.getItem("userId")),
        currency: showAsset,
        positionSize: positionSize,
        fixedAmount: fixedAmount,
        percentValue: percentValue,
        deviationPercent: trimmedPercent,
        marginType: marginType,
        leverage: leverage,
      };

      console.log("postttt limit", payload);

      axios
        .post(
          `${COPYTRADINGSERVICE}/bot/balanceCheckForOwnExchange`,
          JSON.stringify(payload),
          {
            headers: {
              "Content-Type": "application/json",
              authorization: `BEARER ${localStorage.getItem("access_token")}`,
            },
          }
        )
        .then((response) => {
          const result = response.data;
          console.log("result", result);

          if (result.statusCode === 1) {
            setBinanceBalanceCheckStatus(false);
            showToast("success", result.message);
          } else {
            setBinanceBalanceCheckStatus(true);
            showToast("error", result.message);
          }
        })
        .catch((error) => {
          console.error("Error occurred:", error);
          showToast("error", "An error occurred while checking the balance");
        });
    }
  };

  const handleToggleChange = (newValue) => {
    console.log("handleToggleChange", newValue);
    if (newValue !== null) {
      setTogglePortfolioPercentageForBot1(newValue);
      onItemChangebot1(newValue);
    }
  };

  // if (positionSizeForBot1 !== "Percent of Portfolio") {
  //   return null;
  // }

  const onItemChangebot1 = (val) => {
    const newStr = val.replace("%", "");
    setPercentageOfPortfolioForBot1(newStr);

    binanceLimitOrderPriceCheck(
      "",
      deviationPercentageForBot1,
      "LIMIT",
      "PF",
      newStr,
      0,
      percentageOfPortfolioForBot2,
      percentageOfPortfolioForBot3,
      fixedAmountForBot1,
      fixedAmountForBot2,
      fixedAmountForBot3
    );

    paybitoLimitOrderPriceCheck(
      "Percent of Portfolio",
      "Limit Order",
      fixedAmountForBot1,
      fixedAmountForBot2,
      fixedAmountForBot3,
      newStr,
      percentageOfPortfolioForBot2,
      percentageOfPortfolioForBot3,
      deviationPercentageForBot1
    );
  };

  const handleInputChangeFixedAmount = (e) => {
    const value = e.target.value;

    // Allow only numbers and decimal points
    const regex = /^\d*\.?\d*$/;
    if (regex.test(value)) {
      if (FixedPriceChk(value)) {
        setFixedAmountForBot1(value);

        // ngModelChange equivalents
        binanceLimitOrderPriceCheck(
          value,
          deviationPercentageForBot1,
          "LIMIT",
          "FA",
          "",
          percentageOfPortfolioForBot1,
          percentageOfPortfolioForBot2,
          percentageOfPortfolioForBot3,
          0,
          fixedAmountForBot2,
          fixedAmountForBot3
        );

        paybitoLimitOrderPriceCheck(
          "Fixed Amount",
          "Limit Order",
          value,
          fixedAmountForBot2,
          fixedAmountForBot3,
          percentageOfPortfolioForBot1,
          percentageOfPortfolioForBot2,
          percentageOfPortfolioForBot3,
          deviationPercentageForBot1
        );
      }
    }
  };

  const handleInputBlur = () => {
    // onBlur equivalent to Angular's (change)
    fixedAmountminmaxCheck(fixedAmountForBot1, "fixedAmountForBot1");
  };

  const fixedAmountminmaxCheck = (val, id) => {
    if (val < 0.0002) {
      showToast("error", "Amount should be greater than 0.0002");
    }
  };

  // if (positionSizeForBot1 !== "Fixed Amount") {
  //   return null;
  // }

  const lmodtp2PriceChk = (val, val2) => {
    if (val2 === "above") {
      setLmodtp2PriceErrorlwr(false);

      if (val <= Number(ltpData)) {
        setLmodtp2PriceErrorGrt(true);
      } else {
        setLmodtp2PriceErrorGrt(false);
      }
    } else {
      setLmodtp2PriceErrorGrt(false);

      if (val >= Number(ltpData)) {
        setLmodtp2PriceErrorlwr(true);
      } else {
        setLmodtp2PriceErrorlwr(false);
      }
    }
  };

  const onItemChangebot2 = (val) => {
    setPercentageOfPortfolioForBot2(val);

    const newStr = val.replace("%", "");
    const newStr1 = percentageOfPortfolioForBot1.replace("%", "");

    binanceLimitOrderPriceCheck(
      "",
      deviationPercentageForBot2,
      "LIMIT",
      "PF",
      newStr,
      newStr1,
      0,
      percentageOfPortfolioForBot3,
      fixedAmountForBot1,
      fixedAmountForBot2,
      fixedAmountForBot3
    );

    paybitoLimitOrderPriceCheck(
      "Percent of Portfolio",
      "Limit Order",
      fixedAmountForBot1,
      fixedAmountForBot2,
      fixedAmountForBot3,
      newStr1,
      newStr,
      percentageOfPortfolioForBot3,
      deviationPercentageForBot2
    );
  };

  const handleFixedAmountChangeBot2 = (e) => {
    const value = e.target.value;

    // Allow only numbers and decimal points
    if (/^[0-9]*\.?[0-9]*$/.test(value)) {
      if (value.length <= 10) {
        if (FixedPriceChk(value)) {
          setFixedAmountForBot2(value);

          // Equivalent of (change) and (ngModelChange)
          fixedAmountminmaxCheck(value, "fixedAmountForBot2");

          binanceLimitOrderPriceCheck(
            value,
            deviationPercentageForBot2,
            "LIMIT",
            "FA",
            "",
            percentageOfPortfolioForBot1,
            percentageOfPortfolioForBot2,
            percentageOfPortfolioForBot3,
            fixedAmountForBot1,
            0,
            fixedAmountForBot3
          );

          paybitoLimitOrderPriceCheck(
            "Fixed Amount",
            "Limit Order",
            fixedAmountForBot1,
            value,
            fixedAmountForBot3,
            percentageOfPortfolioForBot1,
            percentageOfPortfolioForBot2,
            percentageOfPortfolioForBot3,
            deviationPercentageForBot2
          );
        }
      }
    }
  };

  // if (positionSizeForBot2 !== "Fixed Amount") {
  //   return null;
  // }

  const lmodtp3PriceChk = (val, val2) => {
    if (val2 === "above") {
      setLmodtp3PriceErrorlwr(false);

      if (val <= Number(ltpData)) {
        setLmodtp3PriceErrorGrt(true);
      } else {
        setLmodtp3PriceErrorGrt(false);
      }
    } else {
      setLmodtp3PriceErrorGrt(false);

      if (val >= Number(ltpData)) {
        setLmodtp3PriceErrorlwr(true);
      } else {
        setLmodtp3PriceErrorlwr(false);
      }
    }
  };

  const handleMarketPriceReachForBot3 = (e) => {
    const value = e.target.value;
    setMarketPriceReachForBot3(value);
    lmodtp3PriceChk(e.target.value, marketPriceReachForBot3Type);
    // investingTimeCheck(value);
  };

  const handleChangePercentageOfPortfolioForBot3 = (e) => {
    const value = e.target.value;
    percentageValidation(value, "percentageOfPortfolioForBot3");
    binanceLimitOrderPriceCheck(
      "",
      deviationPercentageForBot3,
      "LIMIT",
      "PF",
      value,
      percentageOfPortfolioForBot1,
      percentageOfPortfolioForBot2,
      0,
      fixedAmountForBot1,
      fixedAmountForBot2,
      fixedAmountForBot3
    );
    paybitoLimitOrderPriceCheck(
      "Percent of Portfolio",
      "Limit Order",
      fixedAmountForBot1,
      fixedAmountForBot2,
      fixedAmountForBot3,
      percentageOfPortfolioForBot2,
      percentageOfPortfolioForBot1,
      value,
      deviationPercentageForBot3
    );
  };

  const onItemChangeBot3 = (val) => {
    setPercentageOfPortfolioForBot3(val);

    // Remove percentage symbol and convert to string
    const newStr = val.replace("%", "");
    const newStr1 = percentageOfPortfolioForBot1.replace("%", "");
    const newStr2 = percentageOfPortfolioForBot2.replace("%", "");

    const newStr3 = parseInt(newStr1) + parseInt(newStr2);

    binanceLimitOrderPriceCheck(
      "",
      deviationPercentageForBot3,
      "LIMIT",
      "PF",
      newStr,
      newStr1,
      newStr2,
      0,
      fixedAmountForBot1,
      fixedAmountForBot2,
      fixedAmountForBot3
    );

    paybitoLimitOrderPriceCheck(
      "Percent of Portfolio",
      "Limit Order",
      fixedAmountForBot1,
      fixedAmountForBot2,
      fixedAmountForBot3,
      newStr2,
      newStr1,
      newStr,
      deviationPercentageForBot3
    );
  };

  const handleChangeFixedAmountForBot3 = (e) => {
    const value = e.target.value;
    if (/^[0-9]*\.?[0-9]*$/.test(value)) {
      if (value.length <= 10) {
        if (FixedPriceChk(value)) {
          setFixedAmountForBot3(value);
          if (value < 0.0002) {
            showToast("error", "Amount should be greater than 0.0002");
          }
        }
      }
    }

    // Call the checks on value change
    binanceLimitOrderPriceCheck(
      value,
      deviationPercentageForBot3,
      "LIMIT",
      "FA",
      "",
      percentageOfPortfolioForBot1,
      percentageOfPortfolioForBot2,
      percentageOfPortfolioForBot3,
      fixedAmountForBot1,
      fixedAmountForBot2,
      0
    );
    paybitoLimitOrderPriceCheck(
      "Fixed Amount",
      "Limit Order",
      fixedAmountForBot1,
      fixedAmountForBot2,
      value,
      percentageOfPortfolioForBot1,
      percentageOfPortfolioForBot2,
      percentageOfPortfolioForBot3,
      deviationPercentageForBot2
    );
  };

  const modSngPriceChk = (val, val2) => {
    if (val2 === "above") {
      setMoSngEntErrorlwr(false);

      if (val <= Number(ltpData)) {
        setMoSngEntErrorGrt(true);
      } else {
        setMoSngEntErrorGrt(false);
      }
    } else {
      setMoSngEntErrorGrt(false);

      if (val >= Number(ltpData)) {
        setMoSngEntErrorlwr(true);
      } else {
        setMoSngEntErrorlwr(false);
      }
    }
  };

  const handlePriceChange = (e) => {
    const value = e.target.value;
    setMarketPriceReachForSingleEntry(value);
    // investingTimeCheck(value);
    modSngPriceChk(e.target.value, marketPriceReachTypeForSingleEntry);
  };

  const handleKeyDown = (e) => {
    if (!/[\d ]/.test(e.key)) {
      e.preventDefault();
    }
  };

  console.log(
    "portfolioPercentageProfit2ForTakeProfit1",
    portfolioPercentageProfit2ForTakeProfit1
  );

  const singeEntryBinanceFixedPriceCheck = (
    amount,
    percent,
    orderType,
    position,
    positionPercent,
    previouesFAmount,
    previousPercent
  ) => {
    if (exchangeName === "BINANCE" || exchangeName === "PAYBITO") {
      const trimmedPercent = percent.replace("%", "");

      let payload = {};

      if (exchangeName === "PAYBITO" && marketName === "FUTURES") {
        payload = {
          symbol: botAssetPairTrimmed,
          side: botOrder,
          exchange: exchangeName,
          market: marketName,
          amount: marketPriceReachForSingleEntry,
          percent: positionPercent,
          orderType: orderType,
          apiKey: selectedApiKeyMulti?.api_key,
          secretKey: apisecretKey,
          currency: selectedApiKeyMulti?.secret_key,
          position: position,
          positionPercent: positionPercent,
          previouesFAmount: previouesFAmount,
          previousPercent: previousPercent,
          marginType: parseInt(marginType),
          leverage: leverage,
        };
      } else {
        payload = {
          symbol: botAssetPairTrimmed,
          side: botOrder,
          exchange: exchangeName,
          market: marketName,
          amount: selelectedSellingAssetBalance,
          percent: positionPercent,
          orderType: orderType,
          apiKey: selectedApiKeyMulti?.api_key,
          secretKey: selectedApiKeyMulti?.secret_key,
          currency: showAsset,
          position: position,
          positionPercent: positionPercent,
          previouesFAmount: previouesFAmount,
          previousPercent: previousPercent,
        };
      }

      console.log("postttt", payload);

      axios
        .post(
          `${COPYTRADINGSERVICE}/bot/checkAmountForOther`,
          JSON.stringify(payload),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `BEARER ${localStorage.getItem("access_token")}`,
            },
          }
        )
        .then((response) => {
          const result = response.data;
          console.log("result", result);

          if (result.statusCode === "1") {
            setBinanceBalanceCheckStatus(false);
            showToast("success", result.message);
          } else {
            setBinanceBalanceCheckStatus(true);
            if (result.message) {
              showToast("error", result.message || "Null");
            }
          }
        })
        .catch((error) => {
          console.error("Error", error);
          showToast("error", "An error occurred while checking the balance.");
        });
    }
  };
  const paybitoMarketOrderPriceCheck = (
    amount,
    orderType,
    position,
    percentValue,
    deviationPercent
  ) => {
    if (exchangeName === "YACRYPTO") {
      const payload = {
        symbol: botAssetPairTrimmed,
        order: botOrder,
        market: marketName,
        orderType: orderType,
        customerId: parseInt(localStorage.getItem("userId")),
        currency: showAsset,
        positionSize: position,
        fixedAmount: amount,
        percentValue: percentValue,
        deviationPercent: deviationPercent,
        marginType: marginType,
        leverage: leverage,
      };

      console.log("test", payload);

      axios
        .post(
          `${COPYTRADINGSERVICE}/bot/balanceCheckForOwnExchange`,
          JSON.stringify(payload),
          {
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + localStorage.getItem("access_token"),
            },
          }
        )
        .then((response) => {
          const result = response.data;
          console.log("result", result);

          if (result.statusCode === 1) {
            setBinanceBalanceCheckStatus(false);
            showToast("success", result.message);
          } else {
            setBinanceBalanceCheckStatus(true);
            showToast("error", result.message);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          showToast("error", "Error occurred while checking balance.");
        });
    }
  };

  const perPforChangePos = (val) => {
    setPercentageOfPortfolioForSingleEntry(val);

    const newStr = val;

    singeEntryBinanceFixedPriceCheck("", "", "MARKET", "PF", newStr, "", "");
    paybitoMarketOrderPriceCheck(
      "",
      "Market Order",
      "Percent of Portfolio",
      newStr,
      ""
    );
  };

  const handleNgModelChange = (value) => {
    if (value > 0.0002) {
      if (FixedPriceChk(value)) {
        setFixedAmountForSingleEntry(value);
        paybitoMarketOrderPriceCheck(
          value,
          "Market Order",
          "Fixed Amount",
          "",
          ""
        );
        singeEntryBinanceFixedPriceCheck(value, "", "MARKET", "FA", "", "", "");
      }
    } else {
      setFixedAmountForSingleEntry(value);
      showToast("error", "Amount should be greater than 0.0002");
    }
  };

  const FixedPriceChk = (value) => {
    if (Number(value) > Number(selelectedSellingAssetBalance)) {
      setFixedCheck(true);
      showToast("error", "You do not have sufficient balance");
      return false;
    }
    setFixedCheck(false);
    return true;
  };

  const checkPercentageValidation = (e) => {
    const input = e.target.value;

    if (!/^\d*$/.test(input)) return false;

    // Limit to 3 digits
    if (input.length > 3) return false;

    // Convert to number to check upper bound
    const numericValue = Number(input);

    if (numericValue > 100) {
      showToast("error", "Percentage cannot exceed 100");
      return false;
    }
    return true;
  };

  const blockNonNumericKeys = (e) => {
    const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
    if (!/[0-9]/.test(e.key) && !allowed.includes(e.key)) {
      e.preventDefault();
    }
  };

  const moLtpPosChkTp1 = (val, val2) => {
    // Determine PnL status
    if (
      (botOrder === "Buy" && val2 === "above") ||
      (botOrder === "Sell" && val2 === "below")
    ) {
      setPNlStatus(true);
    } else {
      setPNlStatus(false);
    }

    // Error validation for TP1 based on direction
    if (val2 === "above") {
      setModtp1PriceErrorlwr(false);

      if (val <= Number(ltpData)) {
        setModtp1PriceErrorGrt(true);
      } else {
        setModtp1PriceErrorGrt(false);
      }
    } else {
      setModtp1PriceErrorGrt(false);

      if (val >= Number(ltpData)) {
        setModtp1PriceErrorlwr(true);
      } else {
        setModtp1PriceErrorlwr(false);
      }
    }
  };

  const moLtpPosChkTp2 = (val, val2) => {
    if (
      (botOrder === "Buy" && val2 === "above") ||
      (botOrder === "Sell" && val2 === "below")
    ) {
      setPNlStatus2(true);
    } else {
      setPNlStatus2(false);
    }

    if (val2 === "above") {
      setModtp2PriceErrorlwr(false);

      if (val <= Number(ltpData)) {
        setModtp2PriceErrorGrt(true);
      } else {
        setModtp2PriceErrorGrt(false);
      }
    } else {
      setModtp2PriceErrorGrt(false);

      if (val >= Number(ltpData)) {
        setModtp2PriceErrorlwr(true);
      } else {
        setModtp2PriceErrorlwr(false);
      }
    }
  };

  const moLtpPosChkTp3 = (val, val2) => {
    if (
      (botOrder === "Buy" && val2 === "above") ||
      (botOrder === "Sell" && val2 === "below")
    ) {
      setPNlStatus3(true);
    } else {
      setPNlStatus3(false);
    }

    if (val2 === "above") {
      setModtp3PriceErrorlwr(false);

      if (val <= Number(ltpData)) {
        setModtp3PriceErrorGrt(true);
      } else {
        setModtp3PriceErrorGrt(false);
      }
    } else {
      setModtp3PriceErrorGrt(false);

      if (val >= Number(ltpData)) {
        setModtp3PriceErrorlwr(true);
      } else {
        setModtp3PriceErrorlwr(false);
      }
    }
  };

  const priceAndPnLValidationtp1 = (val) => {
    const ltp = parseFloat(ltpData);
    const marketPrice = parseFloat(val);

    let a;

    if (
      (botOrder === "Buy" &&
        marketPriceReachProfit1ForTakeProfit === "below") ||
      (botOrder === "Sell" && marketPriceReachProfit1ForTakeProfit === "below")
    ) {
      a = ((ltp - marketPrice) / ltp) * 100;
    } else {
      a = ((marketPrice - ltp) / ltp) * 100;
    }

    setPlPercentProfit1ForTakeProfit(a);
  };
  const priceAndPnLValidationtp2 = (val) => {
    let a;

    if (
      (botOrder === "Buy" &&
        marketPriceReachProfit2ForTakeProfit === "below") ||
      (botOrder === "Sell" && marketPriceReachProfit2ForTakeProfit === "below")
    ) {
      a = ((parseFloat(ltpData) - parseFloat(val)) / parseFloat(ltpData)) * 100;
    } else {
      a = ((parseFloat(val) - parseFloat(ltpData)) / parseFloat(ltpData)) * 100;
    }

    console.log("pnlData", a);
    setPlPercentProfit2ForTakeProfit(a); // assuming useState hook is used
  };

  const priceAndPnLValidationtp3 = (val) => {
    let a;

    if (
      (botOrder === "Buy" &&
        marketPriceReachProfit3ForTakeProfit === "below") ||
      (botOrder === "Sell" && marketPriceReachProfit3ForTakeProfit === "below")
    ) {
      a = ((parseFloat(ltpData) - parseFloat(val)) / parseFloat(ltpData)) * 100;
    } else {
      a = ((parseFloat(val) - parseFloat(ltpData)) / parseFloat(ltpData)) * 100;
    }

    setPlPercentProfit3ForTakeProfit(a);
  };

  const PnLAndValidationtp1 = (val) => {
    const parsePlPercentProfit1ForTakeProfit = parseFloat(val); // state value or prop
    const ltp = parseFloat(ltpData); // state value or prop
    let a;

    if (
      (botOrder === "Buy" &&
        marketPriceReachProfit1ForTakeProfit === "below") ||
      (botOrder === "Sell" && marketPriceReachProfit1ForTakeProfit === "below")
    ) {
      a = -((parsePlPercentProfit1ForTakeProfit * ltp) / 100 - ltp);
    } else {
      a = (parsePlPercentProfit1ForTakeProfit * ltp) / 100 + ltp;
    }

    setMarketPriceProfit1ForTakeProfit(a); // update state
  };

  const PnLAndValidationtp2 = (val) => {
    if (
      (botOrder === "Buy" &&
        marketPriceReachProfit2ForTakeProfit === "below") ||
      (botOrder === "Sell" && marketPriceReachProfit2ForTakeProfit === "below")
    ) {
      var a = -(
        (parseFloat(val) * parseFloat(ltpData)) / 100 -
        parseFloat(ltpData)
      );
    } else {
      var a =
        (parseFloat(val) * parseFloat(ltpData)) / 100 + parseFloat(ltpData);
    }

    setMarketPriceProfit2ForTakeProfit(a);
  };
  const PnLAndValidationtp3 = (val) => {
    let a;

    if (
      (botOrder === "Buy" &&
        marketPriceReachProfit3ForTakeProfit === "below") ||
      (botOrder === "Sell" && marketPriceReachProfit3ForTakeProfit === "below")
    ) {
      a = -(
        (parseFloat(val) * parseFloat(ltpData)) / 100 -
        parseFloat(ltpData)
      );
    } else {
      a = (parseFloat(val) * parseFloat(ltpData)) / 100 + parseFloat(ltpData);
    }

    setMarketPriceProfit3ForTakeProfit(a); // update state in React
  };

  const cheeckpnlValidation = (val, id) => {
    if (val > 100) {
      showToast("error", "Amount cannot be greater than 100");
    }
  };

  const marketSingleEntryPercentagePriceCheck = (
    amount,
    orderType,
    position,
    percentValue1,
    percentValue2,
    percentValue3,
    deviationPercent
  ) => {
    percentValue1 = percentValue1 === "" ? 0 : parseFloat(percentValue1);
    percentValue2 = percentValue2 === "" ? 0 : parseFloat(percentValue2);
    percentValue3 = percentValue3 === "" ? 0 : parseFloat(percentValue3);

    const totalPercent = percentValue1 + percentValue2 + percentValue3;

    paybitoMarketOrderPriceCheck(
      amount,
      orderType,
      position,
      totalPercent,
      deviationPercent
    );
  };

  const MarketTakeProfitBinanceFixedPriceCheck = (
    amount,
    percent,
    orderType,
    position,
    positionPercent,
    previouesFAmount,
    previousPercent1,
    previousPercent2
  ) => {
    if (previousPercent1 === "") {
      previousPercent1 = 0;
    }
    if (previousPercent2 === "") {
      previousPercent2 = 0;
    }

    const prevTotaPercent =
      parseInt(previousPercent1) + parseInt(previousPercent2);

    console.log("vvvvvsv", prevTotaPercent);

    singeEntryBinanceFixedPriceCheck(
      amount,
      percent,
      orderType,
      position,
      positionPercent,
      previouesFAmount,
      prevTotaPercent
    );
  };

  const perPfprofit1orChangePos = (val1, val2, val3) => {
    setPortfolioPercentageProfit1ForTakeProfit1(val1);
    setPortfolioPercentageProfit2ForTakeProfit1(val2);
    setPortfolioPercentageProfit3ForTakeProfit1(val3);

    const newStr = val1.replace("%", "");
    const newStr1 = val2.replace("%", "");
    const newStr2 = val3.replace("%", "");

    MarketTakeProfitBinanceFixedPriceCheck(
      "",
      "",
      "MARKET",
      "PF",
      newStr,
      "",
      newStr1,
      newStr2
    );

    marketSingleEntryPercentagePriceCheck(
      "",
      "Market Order",
      "Percent of Portfolio",
      newStr,
      newStr1,
      newStr2,
      ""
    );
  };

  const validateMarketOrderTPValue = (val1, val2, val3) => {
    console.log("val1, val2, val3", val1, val2, val3);
    let tp1 = val1.replace("%", "");
    let tp2 = val2.replace("%", "");
    let tp3 = val3.replace("%", "");

    console.log("string--->", tp1, tp2, tp3);

    if (tp1 === "") tp1 = "0";
    if (tp2 === "") tp2 = "0";
    if (tp3 === "") tp3 = "0";

    let tp1Int = parseInt(tp1, 10);
    let tp2Int = parseInt(tp2, 10);
    let tp3Int = parseInt(tp3, 10);

    if (Number.isNaN(tp1Int)) tp1Int = 0;
    if (Number.isNaN(tp2Int)) tp2Int = 0;
    if (Number.isNaN(tp3Int)) tp3Int = 0;

    console.log("int", tp1Int, tp2Int, tp3Int);

    const total = tp1Int + tp2Int + tp3Int;

    if (total > 100) {
      setMarketOrderTPError(true);
    } else {
      setMarketOrderTPError(false);
    }

    console.log("added", total);
  };

  const positionDollerChangePos = (val) => {
    setPercentageOfPortfolioForDollarCostAverage(val);

    const newStr = val.replace("%", "");
    singeEntryBinanceFixedPriceCheck("", "", "MARKET", "PF", newStr, "", "");
    paybitoMarketOrderPriceCheck(
      "",
      "Market Order",
      "Percent of Portfolio",
      newStr,
      ""
    );
  };

  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                visibility: "hidden",
                display: { xs: "none", md: "block" },
              }}
            >
              Dummy text
            </Typography>
            <Typography variant="h6" sx={{ color: "gray" }}>
              Create Trade Automation Bots
            </Typography>
            <ContainedButton
              variant="contained"
              startIcon={
                <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
              }
              onClick={() => navigate("/my-bots")}
            >
              Back
            </ContainedButton>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 2 }}></Grid>

        <Grid size={{ xs: 12, sm: 12, md: 8 }}>
          <Paper
            sx={{
              p: 2,
            }}
          >
            <Grid container spacing={2}>
              <Grid size={6}>
                <FormControl fullWidth margin="normal">
                  <InputLabel
                    id="Select Exchange"
                    className="text-theme-dark-blue"
                  >
                    Select Exchange
                  </InputLabel>
                  <Select
                    labelId="Select Exchange"
                    label="Select Exchange"
                    value={exchangeName}
                    onChange={handleExchangeChange}
                    variant="outlined"
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="BINANCE">BINANCE</MenuItem>
                    <MenuItem value="PAYBITO">
                      {brokerBasicInfo?.exchange}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {/* Bot Name */}
              <Grid size={6}>
                <TextField
                  fullWidth
                  label="Bot Name"
                  variant="outlined"
                  value={botName}
                  onChange={(e) => setBotName(e.target.value)}
                  onKeyPress={VALIDATION1}
                  inputProps={{ minLength: 1, maxLength: 30 }}
                  margin="normal"
                />
              </Grid>
              <Grid size={12}>
                {/* Bot Description */}
                <TextField
                  fullWidth
                  label="Bot Description"
                  variant="outlined"
                  multiline
                  minRows={3}
                  maxRows={6}
                  value={botDescription}
                  onChange={(e) => setBotDescription(e.target.value)}
                  onKeyPress={VALIDATION1}
                  inputProps={{ maxLength: 120, minLength: 1 }}
                  margin="normal"
                />
              </Grid>
              <Grid size={6}>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel id="Select Market">Select Market</InputLabel>
                  <Select
                    labelId="Select Market"
                    label="Select Market"
                    value={marketName}
                    onChange={(e) => {
                      setMarketName(e.target.value);
                      getAssetPair(e.target.value);
                    }}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {brokerMarkets?.spot === 1 && (
                      <MenuItem value="SPOT">Spot</MenuItem>
                    )}
                    {brokerMarkets?.futures === 1 && (
                      <MenuItem value="FUTURES">Futures</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
              {/* Margin Type */}

              {marginShowStatus && (
                <Grid size={6}>
                  <FormControl
                    fullWidth
                    disabled={marginTypeOptionStatus}
                    sx={{ mt: 2 }}
                  >
                    <InputLabel id="Select Margin Type">
                      Select Margin Type
                    </InputLabel>
                    <Select
                      labelId="Select Margin Type"
                      label="Select Margin Type"
                      value={marginType}
                      onChange={(e) => {
                        setMarginType(e.target.value);
                        changeMarginType(e.target.value);
                      }}
                    >
                      <MenuItem value="0">Select</MenuItem>
                      <MenuItem value="1">ISO Margin</MenuItem>
                      <MenuItem value="2">Cross Margin</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {/* Leverage Input */}

              {marginShowStatus && (
                <Grid size={6}>
                  <TextField
                    sx={{ mt: 2 }}
                    fullWidth
                    label="Select Leverage (X)"
                    type="number"
                    value={leverage}
                    onChange={(e) => setLeverage(e.target.value)}
                    onBlur={leverageCheck}
                    inputProps={{ min: 2, max: 125 }}
                  />
                </Grid>
              )}

              <Grid size={6}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="Select Order">Select Order</InputLabel>
                  <Select
                    value={botOrder}
                    labelId="Select Order"
                    label="Select Order"
                    onChange={handleOrderChange}
                  >
                    <MenuItem value="">Select Any</MenuItem>
                    <MenuItem value="Buy">Buy</MenuItem>
                    <MenuItem value="Sell">Sell</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {/* API Key Multi Select */}
              <Grid size={12}>
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body1" color="text.primary">
                    Select API Key{" "}
                    <Tooltip
                      title="An API Key once used for one bot cannot be reused again."
                      placement="top"
                    >
                      <InfoIcon fontSize="small" />
                    </Tooltip>
                  </Typography>
                  <Autocomplete
                    disabled={selectedApiKey?.length === 0}
                    options={selectedApiKey || []}
                    getOptionLabel={(option) => option.apiKeyName}
                    value={selectedApiKeyMulti || null}
                    onChange={(e, newValue) => {
                      setSelectedApiKeyMulti(newValue);
                      // handle selection logic here if needed
                    }}
                    componentsProps={{
                      paper: {
                        sx: {
                          backgroundColor: "background.paper", // Gray background for dropdown
                          border: "1px solid white", // White border for dropdown
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder={!selectedApiKeyMulti ? "Select any" : ""}
                      />
                    )}
                  />
                </Box>
              </Grid>

              {/* Select Pair */}

              <Grid size={12}>
                <FormControl fullWidth margin="normal">
                  <Box
                    display="flex"
                    alignItems="center"
                    // justifyContent="space-between"
                  >
                    <Typography variant="body1">Select Pair</Typography>
                    <Tooltip title="A maximum of 2 bots can be created for a single pair - one buy bot and one sell bot.">
                      <InfoIcon sx={{ fontSize: 18, marginLeft: "5px" }} />
                    </Tooltip>
                  </Box>

                  <Select value={botAssetPair} onChange={handlePairChange}>
                    <MenuItem value="">Select Pair</MenuItem>
                    {assetPairBack
                      ?.sort((a, b) => a.baseCurrency - b.baseCurrency)
                      ?.map((pair, index) => {
                        const value =
                          marketName === "SPOT"
                            ? `${pair.currency}-${pair.baseCurrency}-${pair.ltp}`
                            : marketName === "FUTURES"
                            ? `${pair.currency}-${pair.baseCurrency}-${pair.ltp}-${pair.assetPair}`
                            : `${pair.assetPair}-${pair.currency}-${pair.baseCurrency}-${pair.ltp}`;
                        const label =
                          marketName === "SPOT"
                            ? `${pair.currency}-${pair.baseCurrency}`
                            : pair.assetPair;

                        return (
                          <MenuItem key={index} value={value}>
                            {label}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                {/* Available Balance */}
                <TextField
                  fullWidth
                  label={`Your Available Balance`}
                  variant="outlined"
                  value={selelectedSellingAssetBalance}
                  disabled
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                {/* Expire In */}
                <Box display="flex" alignItems="center" gap={1} marginY={2}>
                  <TextField
                    label="Expire In"
                    value={botExpireTime}
                    onChange={(e) => {
                      if (
                        !investingTimeCheck(e.target.value, botExpireTimeType)
                      ) {
                        setBotExpireTime(""); // Clear on blur if invalid
                      } else {
                        setBotExpireTime(e.target.value);
                      }
                    }}
                    inputProps={{ minLength: 1, maxLength: 8 }}
                    fullWidth
                  />
                  <FormControl sx={{ minWidth: 100 }}>
                    <Select
                      value={botExpireTimeType}
                      onChange={(e) => {
                        setBotExpireTimeType(e.target.value);
                        if (
                          !investingTimeCheck(botExpireTime, e.target.value)
                        ) {
                          setBotExpireTime("");
                        }
                      }}
                    >
                      <MenuItem value="min">Min</MenuItem>
                      <MenuItem value="hrs">Hrs</MenuItem>
                      <MenuItem value="days">Days</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
              <Grid size={6}>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel
                    id="order-type-label"
                    // sx={{ color: "primary.main" }}
                  >
                    Select Order Type
                  </InputLabel>
                  <Select
                    labelId="order-type-label"
                    value={orderType}
                    label="Select Order Type"
                    onChange={handleOrderTypeChange}
                  >
                    <MenuItem value="">Select any</MenuItem>
                    <MenuItem value="Market Order">Market Order</MenuItem>
                    <MenuItem value="Limit Order">Limit Order</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {/* Bot Type Select - only if orderType is Market Order */}
              <Grid size={6}>
                {orderType === "Market Order" && (
                  <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel
                      id="bot-type-label"
                      // sx={{ color: "primary.main" }}
                    >
                      Select Bot Type
                    </InputLabel>
                    <Select
                      labelId="bot-type-label"
                      value={botType}
                      label="Select Bot Type"
                      onChange={(e) => setBotType(e.target.value)}
                    >
                      <MenuItem value="">Select</MenuItem>
                      <MenuItem value="Single Entry">Single Entry</MenuItem>
                      <MenuItem value="Take Profit">Take Profit</MenuItem>
                      <MenuItem value="Dollar Cost Average">
                        Dollar Cost Average
                      </MenuItem>
                    </Select>
                  </FormControl>
                )}
              </Grid>
              <Grid size={12}>
                {orderType === "Limit Order" && (
                  <Grid container spacing={2}>
                    <Grid size={12}>
                      <Grid container>
                        <Grid size={12}>
                          <Typography variant="h5">Limit Order Bot</Typography>

                          <Box sx={{ mt: 2 }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  onChange={(e) =>
                                    handleBotSelection("profit1", e)
                                  }
                                />
                              }
                              label="Take Profit 1"
                            />
                            {isProfit1Checked && (
                              <>
                                <Grid
                                  container
                                  spacing={2}
                                  alignItems="start"
                                  sx={{ mb: 2 }}
                                >
                                  <Grid size={{ xs: 6, md: 4 }}>
                                    <Typography>
                                      When the Market price reaches&nbsp;
                                      <Tooltip title="If Above is selected, the value entered here must be greater than the current market price. If Below is selected, the value entered here must be less than the current market price.">
                                        <InfoIcon fontSize="small" />
                                      </Tooltip>
                                    </Typography>
                                  </Grid>

                                  <Grid size={{ xs: 6, md: 2 }}>
                                    <FormControl fullWidth size="small">
                                      <InputLabel id="Select any">
                                        Select Any
                                      </InputLabel>
                                      <Select
                                        labelId="Select any"
                                        label="Select any"
                                        value={marketPriceReachForBotType}
                                        onChange={(e) => {
                                          setMarketPriceReachForBotType(
                                            e.target.value
                                          );
                                          lmodtp1PriceChk(
                                            marketPriceReachForBot1,
                                            e.target.value
                                          );
                                        }}
                                      >
                                        <MenuItem value="">Select any</MenuItem>
                                        <MenuItem value="above">Above</MenuItem>
                                        <MenuItem value="below">Below</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  <Grid size={{ xs: 6, md: 3 }}>
                                    <Typography>
                                      this price a Limit Order shall be placed
                                      with the deviation described below:
                                    </Typography>
                                  </Grid>

                                  <Grid size={{ xs: 6, md: 3 }}>
                                    <TextField
                                      fullWidth
                                      disabled={
                                        marketPriceReachForBotType === ""
                                      }
                                      label="Please enter price"
                                      value={marketPriceReachForBot1}
                                      onChange={(e) => {
                                        setMarketPriceReachForBot1(
                                          e.target.value
                                        );
                                        lmodtp1PriceChk(
                                          e.target.value,
                                          marketPriceReachForBotType
                                        );
                                        // investingTimeCheck(
                                        //   e.target.value,
                                        //   "marketPriceReachForBot1"
                                        // );
                                      }}
                                      helperText={
                                        <>
                                          <Typography
                                            variant="caption"
                                            color="success.main"
                                          >
                                            Current Market Price: {ltpData}
                                          </Typography>
                                          {lmodtp1PriceErrorGrt && (
                                            <Typography
                                              variant="caption"
                                              color="error.main"
                                              display="block"
                                            >
                                              Price should be greater than
                                              Current Market Price.
                                            </Typography>
                                          )}
                                          {lmodtp1PriceErrorlwr && (
                                            <Typography
                                              variant="caption"
                                              color="error.main"
                                              display="block"
                                            >
                                              Price should be lower than Current
                                              Market Price.
                                            </Typography>
                                          )}
                                        </>
                                      }
                                    />
                                  </Grid>
                                </Grid>

                                <Box mt={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="deviation-from-label">
                                      Choose Deviation from
                                    </InputLabel>
                                    <Select
                                      labelId="deviation-from-label"
                                      label="Choose Deviation from"
                                      value={deviationFromForBot1}
                                      onChange={(e) =>
                                        setDeviationFromForBot1(e.target.value)
                                      }
                                    >
                                      <MenuItem value="">Select</MenuItem>
                                      <MenuItem value="marketPrice">
                                        Market Price
                                      </MenuItem>
                                      <MenuItem value="lastPrice">
                                        Last Price
                                      </MenuItem>
                                      <MenuItem value="askPrice">
                                        Ask Price
                                      </MenuItem>
                                      <MenuItem value="bidPrice">
                                        Bid Price
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </Box>

                                <Box mt={2}>
                                  <TextField
                                    fullWidth
                                    label="Deviation %"
                                    value={deviationPercentageForBot1}
                                    onChange={(e) =>
                                      deviationValidationCheck(e)
                                    }
                                    inputProps={{ maxLength: 8 }}
                                  />
                                </Box>

                                <Box
                                  mt={2}
                                  display="flex"
                                  gap={2}
                                  flexWrap="wrap"
                                >
                                  <RadioGroup
                                    name="togglePercentageForBot1"
                                    value={togglePercentageForBot1} // Ensure this is tied to the state
                                    onChange={(e) =>
                                      handleChange(e.target.value)
                                    }
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    {["10%", "25%", "50%"].map((val) => (
                                      <FormControlLabel
                                        key={val}
                                        control={<Radio value={val} />} // Set the value for each Radio
                                        label={val}
                                      />
                                    ))}
                                  </RadioGroup>
                                  <TextField
                                    variant="outlined"
                                    value={showAsset}
                                    inputProps={{ readOnly: true }}
                                    className={
                                      Themecolor === "Dark"
                                        ? "assetBox"
                                        : "assetBox-light"
                                    }
                                  />
                                </Box>

                                {limitOrderTPError && (
                                  <FormHelperText error>
                                    Total percentage value of take profit cannot
                                    be greater than 100%
                                  </FormHelperText>
                                )}

                                <Box mt={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="position-size-label">
                                      Define Position Size
                                    </InputLabel>
                                    <Select
                                      labelId="position-size-label"
                                      label="Define Position Size"
                                      value={positionSizeForBot1}
                                      onChange={(e) =>
                                        setPositionSizeForBot1(e.target.value)
                                      }
                                    >
                                      <MenuItem value="">Select</MenuItem>
                                      <MenuItem value="Percent of Portfolio">
                                        Percent of Portfolio
                                      </MenuItem>
                                      <MenuItem value="Fixed Amount">
                                        Fixed Amount
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </Box>

                                {positionSizeForBot1 ===
                                  "Percent of Portfolio" && (
                                  <>
                                    <Box mt={2}>
                                      <TextField
                                        fullWidth
                                        label="Percentage of Portfolio"
                                        value={percentageOfPortfolioForBot1}
                                        onChange={(e) => {
                                          if (checkPercentageValidation(e)) {
                                            setPercentageOfPortfolioForBot1(
                                              e.target.value
                                            );
                                          } else {
                                            setPercentageOfPortfolioForBot1("");
                                          }
                                          binanceLimitOrderPriceCheck(
                                            "",
                                            deviationPercentageForBot1,
                                            "LIMIT",
                                            "PF",
                                            e.target.value,
                                            0,
                                            percentageOfPortfolioForBot2,
                                            percentageOfPortfolioForBot3,
                                            fixedAmountForBot1,
                                            fixedAmountForBot2,
                                            fixedAmountForBot3
                                          );
                                          paybitoLimitOrderPriceCheck(
                                            "Percent of Portfolio",
                                            "Limit Order",
                                            fixedAmountForBot1,
                                            fixedAmountForBot2,
                                            fixedAmountForBot3,
                                            e.target.value,
                                            percentageOfPortfolioForBot2,
                                            percentageOfPortfolioForBot3,
                                            deviationPercentageForBot1
                                          );
                                        }}
                                        onKeyDown={blockNonNumericKeys}
                                        inputProps={{ maxLength: 3 }}
                                      />
                                    </Box>

                                    <Box
                                      mt={2}
                                      display="flex"
                                      gap={2}
                                      flexWrap="wrap"
                                    >
                                      <RadioGroup
                                        name="togglePortfolioPercentageForBot1"
                                        value={togglePortfolioPercentageForBot1} // Ensure this is tied to the state
                                        onChange={(e) =>
                                          handleToggleChange(e.target.value)
                                        }
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                      >
                                        {[
                                          "10%",
                                          "25%",
                                          "50%",
                                          "75%",
                                          "100%",
                                        ].map((val) => (
                                          <FormControlLabel
                                            key={val}
                                            control={<Radio value={val} />} // Set the value for each Radio
                                            label={val}
                                          />
                                        ))}
                                      </RadioGroup>

                                      <TextField
                                        variant="outlined"
                                        value={showAsset}
                                        inputProps={{ readOnly: true }}
                                      />
                                    </Box>
                                  </>
                                )}

                                {positionSizeForBot1 === "Fixed Amount" && (
                                  <Box mt={2}>
                                    <TextField
                                      fullWidth
                                      label="Fixed Amount"
                                      value={fixedAmountForBot1}
                                      onChange={handleInputChangeFixedAmount}
                                      onBlur={handleInputBlur}
                                      inputProps={{ maxLength: 10 }}
                                    />
                                  </Box>
                                )}
                              </>
                            )}
                          </Box>

                          <Box sx={{ my: 2 }}>
                            <Grid container spacing={2} alignItems="center">
                              <Grid size={12}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={isProfit2Checked}
                                      onChange={(e) =>
                                        handleBotSelection("profit2", e)
                                      }
                                    />
                                  }
                                  label="Take Profit 2"
                                />
                              </Grid>
                            </Grid>

                            {isProfit2Checked && (
                              <Box sx={{ mt: 2 }}>
                                <Grid container spacing={2} alignItems="start">
                                  <Grid size={{ xs: 6, md: 4 }}>
                                    <Typography>
                                      When the Market price reaches{" "}
                                      <Tooltip title="If Above is selected, the value must be greater than the current market price. If Below is selected, it must be lower.">
                                        <InfoIcon fontSize="small" />
                                      </Tooltip>
                                    </Typography>
                                  </Grid>

                                  <Grid size={{ xs: 6, md: 2 }}>
                                    <FormControl fullWidth>
                                      <InputLabel id="Select Any">
                                        Select Any
                                      </InputLabel>
                                      <Select
                                        labelId="Select Any"
                                        label="Select Any"
                                        value={marketPriceReachForBot2Type}
                                        onChange={(e) => (
                                          setMarketPriceReachForBot2Type(
                                            e.target.value
                                          ),
                                          lmodtp2PriceChk(
                                            marketPriceReachForBot2,
                                            e.target.value
                                          )
                                        )}
                                      >
                                        <MenuItem value="">Select any</MenuItem>
                                        <MenuItem value="above">Above</MenuItem>
                                        <MenuItem value="below">Below</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  <Grid size={{ xs: 6, md: 3 }}>
                                    <Typography>
                                      this price a Limit Order shall be placed
                                      with the deviation described below:
                                    </Typography>
                                  </Grid>
                                  <Grid size={{ xs: 6, md: 3 }}>
                                    <TextField
                                      disabled={!marketPriceReachForBot2Type}
                                      fullWidth
                                      placeholder="Please enter price"
                                      value={marketPriceReachForBot2}
                                      onChange={(e) => (
                                        setMarketPriceReachForBot2(
                                          e.target.value
                                        ),
                                        lmodtp2PriceChk(
                                          e.target.value,
                                          marketPriceReachForBot2Type
                                        )
                                      )}
                                      helperText={
                                        <>
                                          <Typography
                                            variant="caption"
                                            color="success.main"
                                          >
                                            Current Market Price: {ltpData}
                                          </Typography>
                                          {lmodtp2PriceErrorGrt && (
                                            <Typography
                                              variant="caption"
                                              color="error.main"
                                              display="block"
                                            >
                                              Price should be greater than
                                              Current Market Price.
                                            </Typography>
                                          )}
                                          {lmodtp2PriceErrorlwr && (
                                            <Typography
                                              variant="caption"
                                              color="error.main"
                                              display="block"
                                            >
                                              Price should be lower than Current
                                              Market Price.
                                            </Typography>
                                          )}
                                        </>
                                      }
                                    />
                                  </Grid>
                                </Grid>

                                <Grid container spacing={2} sx={{ mt: 2 }}>
                                  <Grid size={12}>
                                    <InputLabel>
                                      Choose Deviation from
                                    </InputLabel>
                                    <Select
                                      fullWidth
                                      value={deviationFromForBot2}
                                      onChange={(e) =>
                                        setDeviationFromForBot2(e.target.value)
                                      }
                                    >
                                      <MenuItem value="">Select</MenuItem>
                                      <MenuItem value="marketPrice">
                                        Market Price
                                      </MenuItem>
                                      <MenuItem value="lastPrice">
                                        Last Price
                                      </MenuItem>
                                      <MenuItem value="askPrice">
                                        Ask Price
                                      </MenuItem>
                                      <MenuItem value="bidPrice">
                                        Bid Price
                                      </MenuItem>
                                    </Select>
                                  </Grid>

                                  <Grid size={12}>
                                    <InputLabel>Deviation %</InputLabel>
                                    <TextField
                                      fullWidth
                                      value={deviationPercentageForBot2}
                                      onChange={(e) =>
                                        deviationValidationCheckBot2(e)
                                      }
                                      inputProps={{ maxLength: 8 }}
                                    />
                                  </Grid>
                                  <Grid
                                    size={12}
                                    sx={{ display: "flex", gap: 1 }}
                                  >
                                    <RadioGroup
                                      name="deviationPercentageForBot2"
                                      value={deviationPercentageForBot2} // Ensure this is tied to the state
                                      onChange={(e) => (
                                        setDeviationPercentageForBot2(
                                          e.target.value
                                        ),
                                        validateLimitOrderTPValue(
                                          deviationPercentageForBot1,
                                          e.target.value,
                                          deviationPercentageForBot3
                                        )
                                      )}
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      {["10%", "25%", "50%"].map((val) => (
                                        <FormControlLabel
                                          key={val}
                                          control={<Radio value={val} />} // Set the value for each Radio
                                          label={val}
                                        />
                                      ))}
                                    </RadioGroup>

                                    <TextField
                                      variant="outlined"
                                      size="small"
                                      value={showAsset}
                                      InputProps={{ readOnly: true }}
                                    />
                                  </Grid>
                                </Grid>

                                {limitOrderTPError && (
                                  <Typography variant="caption" color="error">
                                    Total percentage value of take profit cannot
                                    be greater than 100%
                                  </Typography>
                                )}

                                <Grid container spacing={2} sx={{ mt: 2 }}>
                                  <Grid size={12}>
                                    <InputLabel>
                                      Define Position Size
                                    </InputLabel>
                                    <Select
                                      fullWidth
                                      value={positionSizeForBot2}
                                      onChange={(e) =>
                                        setPositionSizeForBot2(e.target.value)
                                      }
                                    >
                                      <MenuItem value="">Select</MenuItem>
                                      <MenuItem value="Percent of Portfolio">
                                        Percent of Portfolio
                                      </MenuItem>
                                      <MenuItem value="Fixed Amount">
                                        Fixed Amount
                                      </MenuItem>
                                    </Select>
                                  </Grid>

                                  {positionSizeForBot2 ===
                                    "Percent of Portfolio" && (
                                    <>
                                      <Grid size={12}>
                                        <InputLabel>
                                          Percentage of Portfolio
                                        </InputLabel>
                                        <TextField
                                          fullWidth
                                          value={percentageOfPortfolioForBot2}
                                          onChange={(e) => {
                                            if (checkPercentageValidation(e)) {
                                              setPercentageOfPortfolioForBot2(
                                                e.target.value
                                              );
                                            } else {
                                              setPercentageOfPortfolioForBot2(
                                                ""
                                              );
                                            }
                                            binanceLimitOrderPriceCheck(
                                              "",
                                              deviationPercentageForBot2,
                                              "LIMIT",
                                              "PF",
                                              e.target.value,
                                              percentageOfPortfolioForBot1,
                                              0,
                                              percentageOfPortfolioForBot3,
                                              fixedAmountForBot1,
                                              fixedAmountForBot2,
                                              fixedAmountForBot3
                                            );
                                            paybitoLimitOrderPriceCheck(
                                              "Percent of Portfolio",
                                              "Limit Order",
                                              fixedAmountForBot1,
                                              fixedAmountForBot2,
                                              fixedAmountForBot3,
                                              percentageOfPortfolioForBot1,
                                              e.target.value,
                                              percentageOfPortfolioForBot3,
                                              deviationPercentageForBot2
                                            );
                                          }}
                                          onKeyDown={blockNonNumericKeys}
                                          inputProps={{ maxLength: 3 }}
                                        />
                                        <RadioGroup
                                          name="percentageOfPortfolioForBot2"
                                          value={percentageOfPortfolioForBot2} // Ensure this is tied to the state
                                          onChange={(e) =>
                                            onItemChangebot2(e.target.value)
                                          }
                                          sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                          }}
                                        >
                                          {[
                                            "10%",
                                            "25%",
                                            "50%",
                                            "75%",
                                            "100%",
                                          ].map((val) => (
                                            <FormControlLabel
                                              key={val}
                                              control={<Radio value={val} />} // Set the value for each Radio
                                              label={val}
                                            />
                                          ))}
                                        </RadioGroup>
                                      </Grid>
                                    </>
                                  )}

                                  {positionSizeForBot2 === "Fixed Amount" && (
                                    <Grid size={12}>
                                      <InputLabel>Fixed Amount</InputLabel>
                                      <TextField
                                        fullWidth
                                        value={fixedAmountForBot2}
                                        onChange={(e) =>
                                          handleFixedAmountChangeBot2(e)
                                        }
                                        inputProps={{ maxLength: 10 }}
                                      />
                                    </Grid>
                                  )}
                                </Grid>
                              </Box>
                            )}
                          </Box>

                          <Box sx={{ my: 2 }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={isProfit3Checked}
                                  onChange={(e) =>
                                    handleBotSelection("profit3", e)
                                  }
                                />
                              }
                              label="Take Profit 3"
                            />

                            {isProfit3Checked && (
                              <>
                                <Grid container spacing={2} alignItems="start">
                                  <Grid size={{ xs: 6, md: 4 }}>
                                    <Typography>
                                      When the Market price reaches
                                      <Tooltip title="If Above is selected, the value entered here must be greater than the current market price. If Below is selected, the value entered here must be less than the current market price.">
                                        <InfoIcon fontSize="small" />
                                      </Tooltip>
                                    </Typography>
                                  </Grid>

                                  <Grid size={{ xs: 6, md: 2 }}>
                                    <FormControl fullWidth>
                                      <InputLabel id="Select Any">
                                        Select Any
                                      </InputLabel>
                                      <Select
                                        labelId="Select Any"
                                        label="Select Any"
                                        value={marketPriceReachForBot3Type}
                                        onChange={(e) => (
                                          setMarketPriceReachForBot3Type(
                                            e.target.value
                                          ),
                                          lmodtp3PriceChk(
                                            marketPriceReachForBot3,
                                            e.target.value
                                          )
                                        )}
                                      >
                                        <MenuItem value="">Select any</MenuItem>
                                        <MenuItem value="above">Above</MenuItem>
                                        <MenuItem value="below">Below</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>

                                  <Grid size={{ xs: 6, md: 3 }}>
                                    <Typography>
                                      this price a Limit Order shall be placed
                                      with the deviation described below:
                                    </Typography>
                                  </Grid>

                                  <Grid size={{ xs: 6, md: 3 }}>
                                    <TextField
                                      fullWidth
                                      placeholder="Please enter price"
                                      value={marketPriceReachForBot3}
                                      onChange={(e) =>
                                        handleMarketPriceReachForBot3(e)
                                      }
                                      helperText={
                                        <>
                                          <Typography
                                            variant="caption"
                                            color="success.main"
                                          >
                                            Current Market Price: {ltpData}
                                          </Typography>
                                          {lmodtp3PriceErrorGrt && (
                                            <Typography
                                              variant="caption"
                                              color="error.main"
                                              display="block"
                                            >
                                              Price should be greater than
                                              Current Market Price.
                                            </Typography>
                                          )}
                                          {lmodtp3PriceErrorlwr && (
                                            <Typography
                                              variant="caption"
                                              color="error.main"
                                              display="block"
                                            >
                                              Price should be lower than Current
                                              Market Price.
                                            </Typography>
                                          )}
                                        </>
                                      }
                                    />
                                  </Grid>
                                </Grid>

                                <FormControl fullWidth sx={{ mt: 2 }}>
                                  <InputLabel id="Choose Deviation">
                                    Choose Deviation from
                                  </InputLabel>
                                  <Select
                                    labelId="Choose Deviation"
                                    label="Choose Deviation from"
                                    value={deviationFromForBot3}
                                    onChange={(e) =>
                                      setDeviationFromForBot3(e.target.value)
                                    }
                                  >
                                    <MenuItem value="">Select</MenuItem>
                                    <MenuItem value="marketPrice">
                                      Market Price
                                    </MenuItem>
                                    <MenuItem value="lastPrice">
                                      Last Price
                                    </MenuItem>
                                    <MenuItem value="askPrice">
                                      Ask Price
                                    </MenuItem>
                                    <MenuItem value="bidPrice">
                                      Bid Price
                                    </MenuItem>
                                  </Select>
                                </FormControl>

                                <TextField
                                  label="Deviation %"
                                  value={deviationPercentageForBot3}
                                  onChange={(e) =>
                                    deviationValidationCheckBot3(e)
                                  }
                                  fullWidth
                                  sx={{ my: 2 }}
                                />

                                <Box
                                  display="flex"
                                  gap={1}
                                  flexWrap="wrap"
                                  mb={2}
                                >
                                  <RadioGroup
                                    name="deviationPercentageForBot3"
                                    value={deviationPercentageForBot3} // Ensure this is tied to the state
                                    onChange={(e) => (
                                      setDeviationPercentageForBot3(
                                        e.target.value
                                      ),
                                      validateLimitOrderTPValue(
                                        deviationPercentageForBot1,
                                        deviationPercentageForBot2,
                                        e.target.value
                                      )
                                    )}
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    {["10%", "25%", "50%"].map((val) => (
                                      <FormControlLabel
                                        key={val}
                                        control={<Radio value={val} />} // Set the value for each Radio
                                        label={val}
                                      />
                                    ))}
                                  </RadioGroup>

                                  <TextField
                                    value={showAsset}
                                    InputProps={{ readOnly: true }}
                                  />
                                </Box>

                                {limitOrderTPError && (
                                  <FormHelperText error>
                                    Total percentage value of take profit cannot
                                    be greater than 100%
                                  </FormHelperText>
                                )}

                                <FormControl fullWidth sx={{ mt: 2 }}>
                                  <InputLabel id="positionSizeForBot3">
                                    Define Position Size
                                  </InputLabel>
                                  <Select
                                    labelId="positionSizeForBot3"
                                    label="Define Position Size"
                                    value={positionSizeForBot3}
                                    onChange={(e) =>
                                      setPositionSizeForBot3(e.target.value)
                                    }
                                  >
                                    <MenuItem value="">Select</MenuItem>
                                    <MenuItem value="Percent of Portfolio">
                                      Percent of Portfolio
                                    </MenuItem>
                                    <MenuItem value="Fixed Amount">
                                      Fixed Amount
                                    </MenuItem>
                                  </Select>
                                </FormControl>

                                {positionSizeForBot3 ===
                                  "Percent of Portfolio" && (
                                  <>
                                    <TextField
                                      label="Percentage Of Portfolio"
                                      value={percentageOfPortfolioForBot3}
                                      onChange={(e) => {
                                        if (checkPercentageValidation(e)) {
                                          setPercentageOfPortfolioForBot3(
                                            e.target.value
                                          );
                                        } else {
                                          setPercentageOfPortfolioForBot3("");
                                        }
                                        handleChangePercentageOfPortfolioForBot3(
                                          e
                                        );
                                      }}
                                      onKeyDown={blockNonNumericKeys}
                                      fullWidth
                                      sx={{ mt: 2 }}
                                    />
                                    <Box
                                      display="flex"
                                      gap={1}
                                      flexWrap="wrap"
                                      mt={1}
                                    >
                                      <RadioGroup
                                        name="percentageOfPortfolioForBot3"
                                        value={percentageOfPortfolioForBot3} // Ensure this is tied to the state
                                        onChange={(e) =>
                                          onItemChangeBot3(e.target.value)
                                        }
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                      >
                                        {[
                                          "10%",
                                          "25%",
                                          "50%",
                                          "75%",
                                          "100%",
                                        ].map((val) => (
                                          <FormControlLabel
                                            key={val}
                                            control={<Radio value={val} />} // Set the value for each Radio
                                            label={val}
                                          />
                                        ))}
                                      </RadioGroup>
                                    </Box>
                                  </>
                                )}

                                {positionSizeForBot3 === "Fixed Amount" && (
                                  <TextField
                                    label="Fixed Amount"
                                    value={fixedAmountForBot3}
                                    onChange={(e) =>
                                      handleChangeFixedAmountForBot3(e)
                                    }
                                    fullWidth
                                    sx={{ mt: 2 }}
                                  />
                                )}
                              </>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
              <Grid size={12}>
                {orderType === "Market Order" && botType === "Single Entry" && (
                  <Paper elevation={2} sx={{ p: 3, mt: 3, borderRadius: 2 }}>
                    <Typography variant="h6" gutterBottom>
                      Single Entry
                    </Typography>

                    {/* Market Price Trigger */}
                    <Grid
                      container
                      spacing={2}
                      // alignItems="center"
                      sx={{ mb: 2 }}
                    >
                      <Grid size={{ xs: 6, md: 5 }}>
                        <Typography>
                          Execute this Market Order when the Market Price
                          reaches at or{" "}
                          <Tooltip title={priceTooltip} arrow>
                            <IconButton size="small">
                              <InfoIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Typography>
                      </Grid>

                      <Grid size={{ xs: 6, md: 2 }}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Direction</InputLabel>
                          <Select
                            value={marketPriceReachTypeForSingleEntry}
                            label="Direction"
                            onChange={(e) => (
                              setMarketPriceReachTypeForSingleEntry(
                                e.target.value
                              ),
                              modSngPriceChk(
                                marketPriceReachForSingleEntry,
                                e.target.value
                              )
                            )}
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="above">Above</MenuItem>
                            <MenuItem value="below">Below</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid size={{ xs: 6, md: 2 }}>
                        <Typography>this price</Typography>
                      </Grid>

                      <Grid size={{ xs: 6, md: 3 }}>
                        <TextField
                          fullWidth
                          type="number"
                          placeholder="Enter target price"
                          size="small"
                          value={marketPriceReachForSingleEntry}
                          onChange={handlePriceChange}
                          // onKeyDown={handleKeyDown}
                          minLength={1}
                          maxLength={10}
                          disabled={marketPriceReachTypeForSingleEntry === ""}
                          // error={!!priceError}
                          helperText={
                            <>
                              <Typography
                                variant="caption"
                                color="success.main"
                              >
                                Current Market Price: {ltpData}
                              </Typography>
                              {moSngEntErrorGrt && (
                                <Typography
                                  variant="caption"
                                  color="error.main"
                                  display="block"
                                >
                                  Price should be greater than Current Market
                                  Price.
                                </Typography>
                              )}
                              {moSngEntErrorlwr && (
                                <Typography
                                  variant="caption"
                                  color="error.main"
                                  display="block"
                                >
                                  Price should be lower than Current Market
                                  Price.
                                </Typography>
                              )}
                            </>
                          }
                        />
                      </Grid>
                    </Grid>

                    {/* Position Size Type */}
                    <Box mt={3}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Define Position Size</InputLabel>
                        <Select
                          value={positionSizeForSingleEntry}
                          label="Define Position Size"
                          onChange={(e) =>
                            setPositionSizeForSingleEntry(e.target.value)
                          }
                        >
                          <MenuItem value="">Select</MenuItem>
                          <MenuItem value="Percent of Portfolio">
                            Percent of Portfolio
                          </MenuItem>
                          <MenuItem value="Fixed Amount">Fixed Amount</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>

                    {/* Percent of Portfolio Section */}
                    {positionSizeForSingleEntry === "Percent of Portfolio" && (
                      <Box mt={3}>
                        <Typography variant="body1" mb={1}>
                          Percentage Of Portfolio
                        </Typography>
                        <TextField
                          fullWidth
                          size="small"
                          value={percentageOfPortfolioForSingleEntry}
                          onChange={(e) => {
                            if (checkPercentageValidation(e)) {
                              setPercentageOfPortfolioForSingleEntry(
                                e.target.value
                              );
                            } else {
                              setPercentageOfPortfolioForSingleEntry("");
                            }
                            singeEntryBinanceFixedPriceCheck(
                              "",
                              "",
                              "MARKET",
                              "PF",
                              e.target.value,
                              "",
                              ""
                            );
                            paybitoMarketOrderPriceCheck(
                              "",
                              "Market Order",
                              "Percent of Portfolio",
                              e.target.value,
                              ""
                            );
                          }}
                          onKeyDown={blockNonNumericKeys}
                          placeholder="Enter percentage"
                          inputProps={{ maxLength: 8 }}
                        />

                        <Box display="flex" flexWrap="wrap" gap={1} mt={2}>
                          <RadioGroup
                            name="percentageOfPortfolioForSingleEntry"
                            value={percentageOfPortfolioForSingleEntry}
                            onChange={(e) =>
                              perPforChangePos(Number(e.target.value))
                            }
                            row // optional, if you want them in a row
                          >
                            {presetPercents.map((val) => (
                              <FormControlLabel
                                key={val}
                                value={val}
                                control={<Radio />}
                                label={`${val}%`}
                              />
                            ))}
                          </RadioGroup>

                          <TextField
                            value={showAsset}
                            InputProps={{ readOnly: true }}
                            size="small"
                            variant="outlined"
                            label="Asset"
                            sx={{ ml: 2 }}
                          />
                        </Box>
                      </Box>
                    )}

                    {/* Fixed Amount Section */}
                    {positionSizeForSingleEntry === "Fixed Amount" && (
                      <Box mt={3}>
                        <Typography variant="body1" mb={1}>
                          Fixed Amount
                        </Typography>
                        <TextField
                          fullWidth
                          size="small"
                          type="number"
                          value={fixedAmountForSingleEntry}
                          onChange={(e) => handleNgModelChange(e.target.value)}
                          inputProps={{ maxLength: 10 }}
                        />
                      </Box>
                    )}
                  </Paper>
                )}
              </Grid>
              <Grid size={12}>
                {orderType === "Market Order" && botType === "Take Profit" && (
                  <Grid
                    container
                    spacing={2}
                    // alignItems="center"
                    sx={{ mb: 2 }}
                  >
                    <Grid size={12}>
                      <Typography variant="h6">
                        Take Profit Market Order Bot
                      </Typography>
                    </Grid>

                    {/* Take Profit 1 Section */}
                    <Grid size={12}>
                      <Box display="flex" alignItems="center">
                        <Checkbox
                          checked={isProfit1CheckedForTakeProfit}
                          onChange={(e) =>
                            handleBotSelection("profit1ForTakeProfit", e)
                          }
                        />
                        <Typography>Take Profit 1</Typography>
                      </Box>
                    </Grid>

                    {isProfit1CheckedForTakeProfit && (
                      <>
                        <Grid size={{ xs: 6, md: 5 }}>
                          <Typography>
                            Execute this Market Order when the Market Price
                            reaches at or{" "}
                            <Tooltip title="If Above is selected, the value entered here must be greater than the current market price. If Below is selected, the value entered here must be less than the current market price.">
                              <IconButton size="small">
                                <InfoIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Typography>
                        </Grid>

                        <Grid size={{ xs: 6, md: 2 }}>
                          <FormControl size="small" sx={{ minWidth: 120 }}>
                            <Select
                              value={marketPriceReachProfit1ForTakeProfit}
                              onChange={(e) => (
                                setMarketPriceReachProfit1ForTakeProfit(
                                  e.target.value
                                ),
                                moLtpPosChkTp1(
                                  marketPriceProfit1ForTakeProfit,
                                  e.target.value
                                )
                              )}
                              displayEmpty
                            >
                              <MenuItem value="">Select any</MenuItem>
                              <MenuItem value="above">Above</MenuItem>
                              <MenuItem value="below">Below</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid size={{ xs: 6, md: 2 }}>
                          <Typography>this price</Typography>
                        </Grid>
                        <Grid size={{ xs: 6, md: 3 }}>
                          <TextField
                            size="small"
                            type="text"
                            inputProps={{ maxLength: 10 }}
                            disabled={!marketPriceReachProfit1ForTakeProfit}
                            placeholder="Please enter price"
                            value={marketPriceProfit1ForTakeProfit}
                            onChange={(e) => {
                              setMarketPriceProfit1ForTakeProfit(
                                e.target.value
                              );
                              priceAndPnLValidationtp1(e.target.value);
                              moLtpPosChkTp1(
                                e.target.value,
                                marketPriceReachProfit1ForTakeProfit
                              );
                            }}
                            // onBlur={() =>
                            //   investingTimeCheck(
                            //     marketPriceProfit1ForTakeProfit,
                            //     "marketPriceProfit1ForTakeProfit"
                            //   )
                            // }
                            sx={{ width: "100%" }}
                            helperText={
                              <>
                                <Typography
                                  variant="caption"
                                  color="success.main"
                                >
                                  Current Market Price: {ltpData}
                                </Typography>
                                {modtp1PriceErrorGrt && (
                                  <Typography
                                    variant="caption"
                                    color="error.main"
                                    display="block"
                                  >
                                    Price should be greater than Current Market
                                    Price.
                                  </Typography>
                                )}
                                {modtp1PriceErrorlwr && (
                                  <Typography
                                    variant="caption"
                                    color="error.main"
                                    display="block"
                                  >
                                    Price should be lower than Current Market
                                    Price.
                                  </Typography>
                                )}
                              </>
                            }
                          />
                        </Grid>

                        <Grid size={6}>
                          <Typography variant="body2" color="textSecondary">
                            Your P/L %
                          </Typography>
                          <TextField
                            size="small"
                            type="text"
                            fullWidth
                            placeholder="Please enter P/L %"
                            inputProps={{ maxLength: 8 }}
                            value={plPercentProfit1ForTakeProfit}
                            onChange={(e) => (
                              setPlPercentProfit1ForTakeProfit(e.target.value),
                              PnLAndValidationtp1(e.target.value)
                            )}
                            onBlur={() =>
                              cheeckpnlValidation(
                                plPercentProfit1ForTakeProfit,
                                "plPercentProfit1ForTakeProfit"
                              )
                            }
                            InputProps={{
                              startAdornment: pNlStatus && (
                                <InputAdornment position="start">
                                  (-)
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>

                        <Grid size={6}>
                          <Typography variant="body2" color="textSecondary">
                            Percentage of Portfolio
                          </Typography>
                          <TextField
                            size="small"
                            type="text"
                            fullWidth
                            inputProps={{ minLength: 1, maxLength: 8 }}
                            value={portfolioPercentageProfit1ForTakeProfit1}
                            onChange={(e) => {
                              if (checkPercentageValidation(e)) {
                                setPortfolioPercentageProfit1ForTakeProfit1(
                                  e.target.value
                                );
                              } else {
                                setPortfolioPercentageProfit1ForTakeProfit1("");
                              }

                              percentageValidation(
                                portfolioPercentageProfit1ForTakeProfit1,
                                "portfolioPercentageProfit1ForTakeProfit1"
                              );
                              singeEntryBinanceFixedPriceCheck(
                                "",
                                "",
                                "MARKET",
                                "PF",
                                portfolioPercentageProfit1ForTakeProfit1,
                                "",
                                ""
                              );
                              marketSingleEntryPercentagePriceCheck(
                                "",
                                "Market Order",
                                "Percent of Portfolio",
                                portfolioPercentageProfit1ForTakeProfit1,
                                portfolioPercentageProfit2ForTakeProfit1,
                                portfolioPercentageProfit3ForTakeProfit1,
                                ""
                              );
                            }}
                            onKeyDown={blockNonNumericKeys}
                            onBlur={() =>
                              percentageValidation(
                                portfolioPercentageProfit1ForTakeProfit1,
                                "portfolioPercentageProfit1ForTakeProfit1"
                              )
                            }
                          />
                        </Grid>

                        <Grid size={12}>
                          <RadioGroup row>
                            {["10%", "25%", "50%", "75%", "100%"].map(
                              (value) => (
                                <FormControlLabel
                                  key={value}
                                  value={value}
                                  control={<Radio size="small" />}
                                  label={value}
                                  onChange={() => {
                                    perPfprofit1orChangePos(
                                      value,
                                      portfolioPercentageProfit2ForTakeProfit1,
                                      portfolioPercentageProfit3ForTakeProfit1
                                    );
                                    validateMarketOrderTPValue(
                                      value,
                                      portfolioPercentageProfit2ForTakeProfit1,
                                      portfolioPercentageProfit3ForTakeProfit1
                                    );
                                  }}
                                />
                              )
                            )}
                            <TextField
                              size="small"
                              value={showAsset}
                              InputProps={{
                                readOnly: true,
                              }}
                              sx={{
                                width: 100,
                                ml: 1,
                              }}
                            />
                          </RadioGroup>
                        </Grid>

                        {marketOrderTPError && (
                          <Grid size={12}>
                            <Typography variant="caption" color="error.main">
                              Total percentage value of take profit cannot be
                              greater than 100%
                            </Typography>
                          </Grid>
                        )}
                      </>
                    )}

                    {/* Take Profit 2 Section */}
                    <Grid size={12}>
                      <Box display="flex" alignItems="center">
                        <Checkbox
                          checked={isProfit2CheckedForTakeProfit}
                          onChange={(e) =>
                            handleBotSelection("profit2ForTakeProfit", e)
                          }
                        />
                        <Typography>Take Profit 2</Typography>
                      </Box>
                    </Grid>

                    {isProfit2CheckedForTakeProfit && (
                      <>
                        <Grid size={{ xs: 6, md: 5 }}>
                          <Typography>
                            Execute this Market Order when the Market Price
                            reaches at or{" "}
                            <Tooltip title="If Above is selected, the value entered here must be greater than the current market price. If Below is selected, the value entered here must be less than the current market price.">
                              <IconButton size="small">
                                <InfoIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Typography>
                        </Grid>

                        <Grid size={{ xs: 6, md: 2 }}>
                          <FormControl size="small" sx={{ minWidth: 120 }}>
                            <Select
                              value={marketPriceReachProfit2ForTakeProfit}
                              onChange={(e) => {
                                setMarketPriceReachProfit2ForTakeProfit(
                                  e.target.value
                                );
                                moLtpPosChkTp2(
                                  marketPriceProfit2ForTakeProfit,
                                  e.target.value
                                );
                              }}
                              displayEmpty
                            >
                              <MenuItem value="">Select any</MenuItem>
                              <MenuItem value="above">Above</MenuItem>
                              <MenuItem value="below">Below</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid size={{ xs: 6, md: 2 }}>
                          <Typography>this price</Typography>
                        </Grid>
                        <Grid size={{ xs: 6, md: 3 }}>
                          <TextField
                            size="small"
                            type="text"
                            inputProps={{ maxLength: 10 }}
                            disabled={!marketPriceReachProfit2ForTakeProfit}
                            placeholder="Please enter price"
                            value={marketPriceProfit2ForTakeProfit}
                            onChange={(e) => {
                              setMarketPriceProfit2ForTakeProfit(
                                e.target.value
                              );
                              priceAndPnLValidationtp2(e.target.value);
                              moLtpPosChkTp2(
                                e.target.value,
                                marketPriceReachProfit2ForTakeProfit
                              );
                            }}
                            // onBlur={() =>
                            //   investingTimeCheck(
                            //     marketPriceProfit2ForTakeProfit,
                            //     "marketPriceProfit2ForTakeProfit"
                            //   )
                            // }
                            sx={{ width: "100%" }}
                            helperText={
                              <>
                                <Typography
                                  variant="caption"
                                  color="success.main"
                                >
                                  Current Market Price: {ltpData}
                                </Typography>
                                {modtp2PriceErrorGrt && (
                                  <Typography
                                    variant="caption"
                                    color="error.main"
                                    display="block"
                                  >
                                    Price should be greater than Current Market
                                    Price.
                                  </Typography>
                                )}
                                {modtp2PriceErrorlwr && (
                                  <Typography
                                    variant="caption"
                                    color="error.main"
                                    display="block"
                                  >
                                    Price should be lower than Current Market
                                    Price.
                                  </Typography>
                                )}
                              </>
                            }
                          />
                        </Grid>

                        <Grid size={6}>
                          <Typography variant="body2" color="textSecondary">
                            Your P/L %
                          </Typography>
                          <TextField
                            size="small"
                            type="text"
                            fullWidth
                            placeholder="Please enter P/L %"
                            inputProps={{ maxLength: 8 }}
                            value={plPercentProfit2ForTakeProfit}
                            onChange={(e) => {
                              setPlPercentProfit2ForTakeProfit(e.target.value);
                              PnLAndValidationtp2(e.target.value);
                            }}
                            onBlur={() =>
                              cheeckpnlValidation(
                                plPercentProfit2ForTakeProfit,
                                "plPercentProfit2ForTakeProfit"
                              )
                            }
                            InputProps={{
                              startAdornment: pNlStatus && (
                                <InputAdornment position="start">
                                  (-)
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>

                        <Grid size={6}>
                          <Typography variant="body2" color="textSecondary">
                            Percentage of Portfolio
                          </Typography>
                          <TextField
                            size="small"
                            type="text"
                            fullWidth
                            inputProps={{ minLength: 1, maxLength: 8 }}
                            value={portfolioPercentageProfit2ForTakeProfit1}
                            onChange={(e) => {
                              if (checkPercentageValidation(e)) {
                                setPortfolioPercentageProfit2ForTakeProfit1(
                                  e.target.value
                                );
                              } else {
                                setPortfolioPercentageProfit2ForTakeProfit1("");
                              }

                              percentageValidation(
                                portfolioPercentageProfit2ForTakeProfit1,
                                "portfolioPercentageProfit2ForTakeProfit1"
                              );
                              singeEntryBinanceFixedPriceCheck(
                                "",
                                "",
                                "MARKET",
                                "PF",
                                portfolioPercentageProfit2ForTakeProfit1,
                                "",
                                ""
                              );
                              marketSingleEntryPercentagePriceCheck(
                                "",
                                "Market Order",
                                "Percent of Portfolio",
                                portfolioPercentageProfit1ForTakeProfit1,
                                portfolioPercentageProfit2ForTakeProfit1,
                                portfolioPercentageProfit3ForTakeProfit1,
                                ""
                              );
                            }}
                            onKeyDown={blockNonNumericKeys}
                            onBlur={() =>
                              percentageValidation(
                                portfolioPercentageProfit2ForTakeProfit1,
                                "portfolioPercentageProfit2ForTakeProfit1"
                              )
                            }
                          />
                        </Grid>

                        <Grid size={12}>
                          <RadioGroup row>
                            {["10%", "25%", "50%", "75%", "100%"].map(
                              (value) => (
                                <FormControlLabel
                                  key={value}
                                  value={value}
                                  control={<Radio size="small" />}
                                  label={value}
                                  onChange={() => {
                                    perPfprofit1orChangePos(
                                      portfolioPercentageProfit1ForTakeProfit1,
                                      value,
                                      portfolioPercentageProfit3ForTakeProfit1
                                    );
                                    validateMarketOrderTPValue(
                                      portfolioPercentageProfit1ForTakeProfit1,
                                      value,
                                      portfolioPercentageProfit3ForTakeProfit1
                                    );
                                  }}
                                />
                              )
                            )}
                            <TextField
                              size="small"
                              value={showAsset}
                              InputProps={{
                                readOnly: true,
                              }}
                              sx={{
                                width: 100,
                                ml: 1,
                              }}
                            />
                          </RadioGroup>
                        </Grid>

                        {marketOrderTPError && (
                          <Grid size={12}>
                            <Typography variant="caption" color="error.main">
                              Total percentage value of take profit cannot be
                              greater than 100%
                            </Typography>
                          </Grid>
                        )}
                      </>
                    )}

                    {/* Take Profit 3 Section */}
                    <Grid size={12}>
                      <Box display="flex" alignItems="center">
                        <Checkbox
                          checked={isProfit3CheckedForTakeProfit}
                          onChange={(e) =>
                            handleBotSelection("profit3ForTakeProfit", e)
                          }
                        />
                        <Typography>Take Profit 3</Typography>
                      </Box>
                    </Grid>

                    {isProfit3CheckedForTakeProfit && (
                      <>
                        <Grid size={{ xs: 6, md: 5 }}>
                          <Typography>
                            Execute this Market Order when the Market Price
                            reaches at or{" "}
                            <Tooltip title="If Above is selected, the value entered here must be greater than the current market price. If Below is selected, the value entered here must be less than the current market price.">
                              <IconButton size="small">
                                <InfoIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Typography>
                        </Grid>

                        <Grid size={{ xs: 6, md: 2 }}>
                          <FormControl size="small" sx={{ minWidth: 120 }}>
                            <Select
                              value={marketPriceReachProfit3ForTakeProfit}
                              onChange={(e) => {
                                setMarketPriceReachProfit3ForTakeProfit(
                                  e.target.value
                                );
                                moLtpPosChkTp3(
                                  marketPriceProfit3ForTakeProfit,
                                  e.target.value
                                );
                              }}
                              displayEmpty
                            >
                              <MenuItem value="">Select any</MenuItem>
                              <MenuItem value="above">Above</MenuItem>
                              <MenuItem value="below">Below</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid size={{ xs: 6, md: 2 }}>
                          <Typography>this price</Typography>
                        </Grid>
                        <Grid size={{ xs: 6, md: 3 }}>
                          <TextField
                            size="small"
                            type="text"
                            inputProps={{ maxLength: 10 }}
                            disabled={!marketPriceReachProfit3ForTakeProfit}
                            placeholder="Please enter price"
                            value={marketPriceProfit3ForTakeProfit}
                            onChange={(e) => {
                              setMarketPriceProfit3ForTakeProfit(
                                e.target.value
                              );
                              priceAndPnLValidationtp3(e.target.value);
                              moLtpPosChkTp3(
                                e.target.value,
                                marketPriceReachProfit3ForTakeProfit
                              );
                            }}
                            // onBlur={() =>
                            //   investingTimeCheck(
                            //     marketPriceProfit3ForTakeProfit,
                            //     "marketPriceProfit3ForTakeProfit"
                            //   )
                            // }
                            sx={{ width: "100%" }}
                            helperText={
                              <>
                                <Typography
                                  variant="caption"
                                  color="success.main"
                                >
                                  Current Market Price: {ltpData}
                                </Typography>
                                {modtp1PriceErrorGrt && (
                                  <Typography
                                    variant="caption"
                                    color="error.main"
                                    display="block"
                                  >
                                    Price should be greater than Current Market
                                    Price.
                                  </Typography>
                                )}
                                {modtp1PriceErrorlwr && (
                                  <Typography
                                    variant="caption"
                                    color="error.main"
                                    display="block"
                                  >
                                    Price should be lower than Current Market
                                    Price.
                                  </Typography>
                                )}
                              </>
                            }
                          />
                        </Grid>

                        <Grid size={6}>
                          <Typography variant="body2" color="textSecondary">
                            Your P/L %
                          </Typography>
                          <TextField
                            size="small"
                            type="text"
                            fullWidth
                            placeholder="Please enter P/L %"
                            inputProps={{ maxLength: 8 }}
                            value={plPercentProfit3ForTakeProfit}
                            onChange={(e) => {
                              setPlPercentProfit3ForTakeProfit(e.target.value);
                              PnLAndValidationtp3(e.target.value);
                            }}
                            onBlur={() =>
                              cheeckpnlValidation(
                                plPercentProfit3ForTakeProfit,
                                "plPercentProfit3ForTakeProfit"
                              )
                            }
                            InputProps={{
                              startAdornment: pNlStatus && (
                                <InputAdornment position="start">
                                  (-)
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>

                        <Grid size={6}>
                          <Typography variant="body2" color="textSecondary">
                            Percentage of Portfolio
                          </Typography>
                          <TextField
                            size="small"
                            type="text"
                            fullWidth
                            inputProps={{ minLength: 1, maxLength: 8 }}
                            value={portfolioPercentageProfit3ForTakeProfit1}
                            onChange={(e) => {
                              if (checkPercentageValidation(e)) {
                                setPortfolioPercentageProfit3ForTakeProfit1(
                                  e.target.value
                                );
                              } else {
                                setPortfolioPercentageProfit3ForTakeProfit1("");
                              }

                              percentageValidation(
                                portfolioPercentageProfit3ForTakeProfit1,
                                "portfolioPercentageProfit3ForTakeProfit1"
                              );
                              singeEntryBinanceFixedPriceCheck(
                                "",
                                "",
                                "MARKET",
                                "PF",
                                portfolioPercentageProfit3ForTakeProfit1,
                                "",
                                ""
                              );
                              marketSingleEntryPercentagePriceCheck(
                                "",
                                "Market Order",
                                "Percent of Portfolio",
                                portfolioPercentageProfit1ForTakeProfit1,
                                portfolioPercentageProfit2ForTakeProfit1,
                                portfolioPercentageProfit3ForTakeProfit1,
                                ""
                              );
                            }}
                            onKeyDown={blockNonNumericKeys}
                            onBlur={() =>
                              percentageValidation(
                                portfolioPercentageProfit1ForTakeProfit1,
                                "portfolioPercentageProfit1ForTakeProfit1"
                              )
                            }
                          />
                        </Grid>

                        <Grid size={12}>
                          <RadioGroup row>
                            {["10%", "25%", "50%", "75%", "100%"].map(
                              (value) => (
                                <FormControlLabel
                                  key={value}
                                  value={value}
                                  control={<Radio size="small" />}
                                  label={value}
                                  onChange={() => {
                                    perPfprofit1orChangePos(
                                      portfolioPercentageProfit1ForTakeProfit1,
                                      portfolioPercentageProfit2ForTakeProfit1,
                                      value
                                    );
                                    validateMarketOrderTPValue(
                                      portfolioPercentageProfit1ForTakeProfit1,
                                      portfolioPercentageProfit2ForTakeProfit1,
                                      value
                                    );
                                  }}
                                />
                              )
                            )}
                            <TextField
                              size="small"
                              value={showAsset}
                              InputProps={{
                                readOnly: true,
                              }}
                              sx={{
                                width: 100,
                                ml: 1,
                              }}
                            />
                          </RadioGroup>
                        </Grid>

                        {marketOrderTPError && (
                          <Grid size={12}>
                            <Typography variant="caption" color="error.main">
                              Total percentage value of take profit cannot be
                              greater than 100%
                            </Typography>
                          </Grid>
                        )}
                      </>
                    )}
                  </Grid>
                )}
              </Grid>
              <Grid size={12}>
                {orderType === "Market Order" &&
                  botType === "Dollar Cost Average" && (
                    <Grid container spacing={2}>
                      {/* Title */}
                      <Grid size={12}>
                        <h6 className="py-2 text-secondary">
                          Dollar Cost Average Market Order Bot
                        </h6>
                      </Grid>

                      {/* Position Size Selector */}
                      <Grid size={12}>
                        <FormControl fullWidth>
                          <InputLabel>Define Position Size</InputLabel>
                          <Select
                            value={positionSizeForDollarCostAverage}
                            onChange={(e) =>
                              handlePositionSizeChange(e.target.value)
                            }
                            label="Define Position Size"
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Percent of Portfolio">
                              Percent of Portfolio
                            </MenuItem>
                            <MenuItem value="Fixed Amount">
                              Fixed Amount
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      {/* Percentage of Portfolio */}
                      {positionSizeForDollarCostAverage ===
                        "Percent of Portfolio" && (
                        <>
                          <Grid size={12}>
                            <TextField
                              label="Percentage Of Portfolio"
                              type="text"
                              value={percentageOfPortfolioForDollarCostAverage}
                              onChange={(e) => {
                                if (checkPercentageValidation(e)) {
                                  setPercentageOfPortfolioForDollarCostAverage(
                                    e.target.value
                                  );
                                } else {
                                  setPercentageOfPortfolioForDollarCostAverage(
                                    ""
                                  );
                                }
                                handlePercentageChange(e);
                              }}
                              onKeyDown={blockNonNumericKeys}
                              onBlur={(e) =>
                                percentageValidation(e.target.value)
                              }
                              fullWidth
                            />
                          </Grid>

                          {/* Radio Buttons for Percentage Selection */}
                          <Grid size={12}>
                            <RadioGroup row>
                              {["10%", "25%", "50%", "75%", "100%"].map(
                                (value) => (
                                  <FormControlLabel
                                    key={value}
                                    value={value}
                                    control={<Radio size="small" />}
                                    label={value}
                                    onChange={() =>
                                      positionDollerChangePos(value)
                                    }
                                  />
                                )
                              )}
                              <TextField
                                label="Asset"
                                value={showAsset}
                                InputProps={{
                                  readOnly: true,
                                }}
                                sx={{
                                  width: 100,
                                  ml: 1,
                                }}
                              />
                            </RadioGroup>
                          </Grid>
                        </>
                      )}

                      {/* Fixed Amount */}
                      {positionSizeForDollarCostAverage === "Fixed Amount" && (
                        <Grid size={12}>
                          <TextField
                            label="Fixed Amount"
                            type="number"
                            value={fixedAmountForDollarCostAverage}
                            onChange={handleFixedAmountChange}
                            onBlur={handleBlurFixedAmountChange}
                            fullWidth
                          />
                        </Grid>
                      )}

                      {/* Investing Time Interval */}
                      <Grid size={6}>
                        <TextField
                          label="Investing Time Interval"
                          type="number"
                          value={investTimeForDolarCostAverage}
                          onChange={handleInvestTimeChange}
                          fullWidth
                        />
                      </Grid>
                      <Grid size={2}></Grid>
                      <Grid size={4}>
                        <FormControl fullWidth>
                          <InputLabel>Time Unit</InputLabel>
                          <Select
                            value={investTimeForDolarCostAverageType}
                            onChange={handleInvestTimeTypeChange}
                            label="Time Unit"
                          >
                            <MenuItem value="min">Mins</MenuItem>
                            <MenuItem value="hrs">Hours</MenuItem>
                            <MenuItem value="days">Days</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  )}
              </Grid>
              <Grid size={6}>
                <Box className="row d-flex">
                  {!isValid() && (
                    <Typography
                      variant="body1"
                      color="error"
                      sx={{ paddingLeft: "14px" }}
                    >
                      Please fill all the fields to create the bot.
                    </Typography>
                  )}
                </Box>
              </Grid>
              <Grid size={6}></Grid>
              <Grid size={12} sx={{ textAlign: "center" }}>
                <ContainedButton
                  variant="contained"
                  disabled={!isValid() || fixedPricechk || ltpValidation()}
                  onClick={createBotApiCall}
                >
                  Create Bot
                </ContainedButton>
              </Grid>
              {/* <Grid container spacing={2} style={{ marginTop: "15px" }}></Grid> */}
            </Grid>
          </Paper>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 2 }}></Grid>
      </Grid>
    </Box>
  );
};

export default CreateBot;
